{
  "app": {
    "name": "Fidelen",
    "tagline": "Centralised procurement operating system",
    "loading": "Loading…",
    "saving": "Saving…",
    "retry": "Try again",
    "cancel": "Cancel",
    "save": "Save",
    "create": "Create",
    "edit": "Edit",
    "archive": "Archive",
    "search": "Search",
    "filter": "Filters",
    "clear": "Clear",
    "confirm": "Confirm",
    "close": "Close",
    "back": "Back",
    "next": "Next",
    "previous": "Previous",
    "reason": "Reason",
    "recordedText": "Recorded text",
    "optional": "optional",
    "yes": "Yes",
    "no": "No",
    "actions": "Actions",
    "status": "Status",
    "none": "None",
    "all": "All",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "delete": "Delete",
    "archiveNotice": "Archiving withdraws this record from use. History that points at it is kept, and there is no way to un-archive it.",
    "select": "Select…",
    "notes": "Notes",
    "fixFields": "Each problem below takes you to its field:",
    "dismiss": "Dismiss"
  },
  "auth": {
    "signIn": "Sign in",
    "signOut": "Sign out",
    "email": "Email address",
    "password": "Password",
    "organisation": "Organisation",
    "signingIn": "Signing in…",
    "welcome": "Welcome to Fidelen",
    "signInSubtitle": "Sign in to reach your organisation's workspace"
  },
  "mfa": {
    "signedInAs": "Signed in as",
    "expiredTitle": "This sign-in has timed out",
    "expiredBody": "For your security, the second step must be finished within a few minutes of your password. Sign in again to continue.",
    "signInAgain": "Sign in again",
    "code": "6-digit code",
    "codeHint": "The code changes every 30 seconds. Type the one your app shows now.",
    "codeRequired": "Type the 6-digit code from your authenticator app",
    "recoveryCode": "Recovery code",
    "recoveryCodeRequired": "Type one of your recovery codes",
    "verify": "Verify",
    "verifying": "Checking…",
    "copied": "Copied",
    "challenge": {
      "title": "Enter your authenticator code",
      "body": "Open the authenticator app on your phone and type the 6-digit code it shows for Fidelen.",
      "useRecovery": "Use a recovery code instead"
    },
    "recovery": {
      "title": "Use a recovery code",
      "body": "Type one of the recovery codes you stored when you set up two-step sign-in. Each code works only once.",
      "useAuthenticator": "Use my authenticator app instead",
      "doneTitle": "You are signed in with a recovery code",
      "doneBody": "That code no longer works. Each recovery code signs you in once, so keep the others safe.",
      "lostPhone": "If you no longer have your authenticator app, replace it now. Another recovery code confirms it is you.",
      "replaceNow": "Replace my authenticator",
      "remaining": "Recovery codes left: {{count}}",
      "continue": "Continue"
    },
    "enrol": {
      "title": "Set up two-step sign-in",
      "body": "Your role needs a second step when you sign in: a code from an authenticator app on your phone. Setting it up takes about two minutes.",
      "need": "You will need an authenticator app on your phone. Any app that supports time-based codes works.",
      "start": "Start setup",
      "scanTitle": "Add Fidelen to your authenticator app",
      "scanBody": "In your authenticator app, add an account and scan this QR code.",
      "qrAlt": "QR code that adds Fidelen to your authenticator app",
      "manualKey": "Can't scan? Type this setup key into the app instead:",
      "copyKey": "Copy key",
      "expires": "Finish before {{time}}.",
      "confirmCode": "Code from the app",
      "confirmHint": "Type the 6-digit code the app now shows for Fidelen.",
      "confirm": "Confirm",
      "restart": "Start again with a new QR code"
    },
    "codes": {
      "title": "Store your recovery codes",
      "once": "These codes are shown only this once. If you lose your phone, each code lets you sign in one time. Keep them somewhere safe that is not your phone, such as a password manager or a printed copy kept locked away.",
      "listLabel": "Your recovery codes",
      "copy": "Copy all codes",
      "stored": "I have stored these codes somewhere safe",
      "storedRequired": "Confirm that you have stored the codes before you continue",
      "continue": "Continue"
    },
    "reauth": {
      "body": "Enter your password and the code your authenticator app shows now.",
      "bodyRecovery": "Enter your password and one of your unused recovery codes. That code will then no longer work.",
      "passwordRequired": "Enter your password",
      "continue": "Continue"
    },
    "security": {
      "title": "Sign-in security",
      "subtitle": "How you prove it is you when you sign in",
      "cardTitle": "Two-step sign-in",
      "cardSubtitle": "Your password, then a code from an authenticator app",
      "status": "Status",
      "on": "On",
      "off": "Off",
      "requirement": "For your role",
      "required": "Required",
      "optional": "Optional",
      "since": "Set up on",
      "codesLeft": "Recovery codes left",
      "codesLow": "You have few recovery codes left. Create new ones.",
      "offBody": "Two-step sign-in is off. Your role does not require it, but it makes your account much harder to break into.",
      "setUp": "Set up two-step sign-in",
      "replace": "Replace authenticator",
      "replaceHint": "For a new phone. Your current app keeps working until you confirm the new one.",
      "replaceTitle": "Replace your authenticator",
      "regenerate": "Create new recovery codes",
      "regenerateHint": "Your current recovery codes stop working as soon as the new ones are created.",
      "regenerateTitle": "Create new recovery codes",
      "disable": "Turn off two-step sign-in",
      "disableHint": "You will sign in with your password only.",
      "disableTitle": "Turn off two-step sign-in",
      "requiredNote": "Your role requires two-step sign-in, so it cannot be turned off.",
      "setupDone": "Two-step sign-in is on.",
      "replaced": "Your new authenticator is in use. The old one no longer works.",
      "regenerated": "Your new recovery codes are ready. The old ones no longer work.",
      "disabled": "Two-step sign-in is off.",
      "changedElsewhere": "Your sign-in security changed in another window or on another device. Nothing was changed here; this page now shows where it stands."
    }
  },
  "activation": {
    "title": "Set up your account",
    "subtitle": "Choose a password and your account is ready",
    "checking": "Checking your invitation…",
    "password": "Choose a password",
    "passwordHint": "Something you will remember and no one else can guess",
    "confirmPassword": "Type the password again",
    "passwordRequired": "Enter a password",
    "passwordMismatch": "The two passwords are not the same",
    "activate": "Activate my account",
    "activating": "Activating…",
    "expires": "This link stops working on {{date}}",
    "unavailableTitle": "This link cannot be used",
    "unavailableBody": "Ask the person who invited you to send you a new invitation link.",
    "successTitle": "Your account is ready",
    "successBody": "You can now sign in with {{email}}."
  },
  "nav": {
    "dashboard": "Dashboard",
    "organization": "Organisation",
    "regions": "Regions",
    "warehouses": "Warehouses",
    "categories": "Categories",
    "administration": "Administration",
    "users": "Users",
    "roles": "Roles",
    "delegations": "Delegations",
    "currencies": "Currencies",
    "taxCodes": "Tax codes",
    "settings": "Settings",
    "audit": "Audit trail",
    "profile": "Profile",
    "suppliers": "Suppliers",
    "agreements": "Framework agreements",
    "catalogue": "Catalogue",
    "procurement": "Procurement",
    "vendorPortal": "Vendor portal",
    "budgets": "Budgets",
    "approvalRules": "Approval rules",
    "policy": "Policy",
    "cart": "Cart",
    "myRequests": "My Requests",
    "approvals": "Approvals",
    "purchaseOrders": "Purchase orders",
    "vendorOrders": "Orders",
    "purchasingUnits": "Purchasing units",
    "receiving": "Receiving",
    "sourcing": "Sourcing",
    "onboarding": "Setup & imports",
    "reports": "Reports",
    "catalogueAdmin": "Catalogue administration",
    "organizationProfile": "Organisation profile",
    "account": "Your account",
    "signInSecurity": "Sign-in security",
    "more": "More"
  },
  "status": {
    "active": "Active",
    "inactive": "Inactive",
    "archived": "Archived",
    "invited": "Invited",
    "suspended": "Suspended",
    "scheduled": "Scheduled",
    "expired": "Expired",
    "revoked": "Revoked",
    "terminated": "Terminated",
    "under_review": "Under review",
    "qualified": "Qualified"
  },
  "enums": {
    "request_status": {
      "draft": "Draft",
      "pending_approval": "Pending approval",
      "approved": "Approved",
      "returned": "Returned for amendment",
      "rejected": "Rejected",
      "cancelled": "Cancelled",
      "procurement_review": "With procurement",
      "sourcing_required": "Sourcing required",
      "procurement_processing": "Procurement processing",
      "po_created": "PO created"
    },
    "approval_status": {
      "pending": "Pending",
      "approved": "Approved",
      "rejected": "Rejected",
      "returned": "Returned for amendment",
      "skipped": "Skipped",
      "cancelled": "Cancelled"
    },
    "budget_health": {
      "within": "Within budget",
      "warning": "Approaching limit",
      "exceeded": "Over budget",
      "no_budget": "No budget defined"
    },
    "purchasing_unit_kind": {
      "branch": "Branch",
      "warehouse": "Warehouse",
      "head_office": "Head office",
      "department": "Department",
      "business_unit": "Business unit",
      "project_site": "Project site",
      "clinic": "Clinic",
      "school": "School",
      "other": "Other"
    },
    "purchasing_unit_status": {
      "draft": "Draft",
      "active": "Active",
      "inactive": "Inactive"
    },
    "receivingException": {
      "short": "Short",
      "over": "Over-delivered",
      "damaged": "Damaged",
      "incorrect": "Incorrect item",
      "rejected": "Rejected",
      "overdue": "Overdue"
    },
    "budget_status": {
      "draft": "Draft",
      "active": "Active",
      "frozen": "Frozen",
      "closed": "Closed"
    },
    "agreement_status": {
      "draft": "Draft",
      "active": "Active",
      "suspended": "Suspended",
      "expired": "Expired",
      "terminated": "Terminated"
    }
  },
  "region": {
    "title": "Regions",
    "subtitle": "Group purchasing units for permissions and reporting",
    "code": "Code",
    "nameEn": "Name (English)",
    "nameAr": "Name (Arabic)",
    "branchCount": "Purchasing units",
    "create": "Add region",
    "empty": "No regions have been created yet",
    "archiveConfirm": "This region will be archived. A region with active purchasing units cannot be archived."
  },
  "branch": {
    "title": "Purchasing units",
    "code": "Code",
    "region": "Region",
    "costCenter": "Cost centre",
    "isReceiving": "Receiving location"
  },
  "warehouse": {
    "title": "Warehouses",
    "subtitle": "Internal fulfilment sources — no stock accounting",
    "create": "Add warehouse",
    "empty": "No warehouses defined",
    "noStockNotice": "In Layer 1 warehouses are fulfilment sources only; Fidelen holds no stock balances.",
    "single": "Warehouse",
    "region": "Region",
    "serves": "Serves",
    "servesCount": "Purchasing units served: {{count}}",
    "servesNone": "Serves no purchasing unit.",
    "servesNoneHint": "It cannot price any item until it is assigned to one.",
    "coverage": "Coverage",
    "coverageTitle": "Warehouse coverage",
    "coverageHint": "Choose the purchasing units this warehouse serves. This is a coverage map — not a routing rule and not a stock allocation.",
    "phone": "Phone",
    "email": "Email",
    "emptyHint": "Entirely normal — an organisation that buys everything from suppliers never needs one."
  },
  "category": {
    "title": "Categories",
    "subtitle": "Your category tree, mapped to standard procurement types",
    "parent": "Parent category",
    "standardType": "Standard type",
    "depth": "Level",
    "create": "Add category",
    "empty": "No categories have been created yet",
    "tree": "Tree",
    "list": "List",
    "edit": "Edit category",
    "topLevel": "Top level",
    "parentFixedNotice": "The parent is not changed here. Moving a category would move every budget, approval rule and past request scoped to it."
  },
  "user": {
    "title": "Users",
    "subtitle": "People, their roles and their scope",
    "name": "Name",
    "nameAr": "Name (Arabic)",
    "jobTitle": "Job title",
    "roles": "Roles",
    "scope": "Scope",
    "lastLogin": "Last sign-in",
    "create": "Add user",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "resetPassword": "Reset password",
    "generatedPassword": "Temporary password",
    "generatedPasswordNotice": "Copy this password now — it is never shown again.",
    "scopeTenant": "Whole organisation",
    "scopeRegion": "Region",
    "scopeBranch": "Purchasing unit",
    "empty": "No users",
    "email": "Email",
    "phone": "Phone"
  },
  "role": {
    "title": "Roles",
    "subtitle": "Named bundles of permissions",
    "permissions": "Permissions",
    "systemRole": "System role",
    "userCount": "Users",
    "create": "Add role",
    "cannotGrantNotice": "You cannot grant a permission you do not hold yourself.",
    "empty": "No roles yet"
  },
  "delegation": {
    "title": "Delegations",
    "subtitle": "Time-bound transfer of authority",
    "delegator": "Delegator",
    "delegate": "Delegate",
    "startsAt": "Starts",
    "endsAt": "Ends",
    "maxAmount": "Amount ceiling",
    "revoke": "Revoke",
    "revokeFor": "Revoke delegation to {{name}}",
    "revokeTitle": "Revoke this delegation?",
    "revokeBody": "{{delegate}} stops acting for {{delegator}} straight away. Anything already decided stays as it was recorded.",
    "revokeFinal": "A revoked delegation cannot be switched back on. If it is needed again, create a new one.",
    "revokeReasonHint": "Optional. It is saved with the change, so it can be explained later.",
    "revokeKeep": "Keep delegation",
    "revokedTitle": "Delegation revoked",
    "revokedBody": "{{delegate}} can no longer act for {{delegator}}. The change is recorded in the audit trail, with who made it and when.",
    "revokedAudit": "Open the audit trail",
    "revokeForbidden": "You cannot revoke this delegation. Only the person who granted it, or an administrator with that right, can.",
    "revokeClosed": "This delegation is already closed, so nothing was changed. The list now shows its current state.",
    "byGrantor": "Only the grantor can revoke",
    "create": "Create delegation",
    "activeNow": "Active now",
    "empty": "No delegations"
  },
  "finance": {
    "currencies": "Currencies",
    "currency": "Currency",
    "currenciesSubtitle": "Currencies enabled for your organisation",
    "taxCodes": "Tax codes",
    "taxCodesSubtitle": "Configurable tax treatments",
    "rate": "Rate",
    "kind": "Kind",
    "isDefault": "Default",
    "effectiveFrom": "Effective from",
    "effectiveTo": "Effective to",
    "enableCurrency": "Enable currency",
    "rateToDefault": "Rate to default currency",
    "kinds": {
      "standard": "Standard",
      "zero_rated": "Zero-rated",
      "exempt": "Exempt",
      "out_of_scope": "Out of scope",
      "reverse_charge": "Reverse charge"
    },
    "currenciesEmpty": "No currencies are enabled yet"
  },
  "settings": {
    "title": "Settings",
    "subtitle": "Behaviour you can change without a code change",
    "managedByFidelen": "Managed by Fidelen",
    "defaultValue": "Default",
    "requiresEntitlement": "Requires subscription",
    "configuredNotEffective": "Saved, but not active — this capability is not part of your agreement with Fidelen. Contact us to enable it.",
    "notIncluded": "This capability is not part of your agreement with Fidelen.",
    "on": "on",
    "off": "off",
    "approvalTypes": {
      "automatic": "No human approval",
      "exception_only": "Approval only when something departs from the rules",
      "one_level": "One approval level",
      "two_level": "Two approval levels"
    }
  },
  "audit": {
    "title": "Audit trail",
    "subtitle": "Who did what, and when",
    "action": "Action",
    "actor": "Actor",
    "entity": "Record",
    "channel": "Channel",
    "when": "When",
    "requestId": "Request id",
    "empty": "No matching entries",
    "domain": "Domain",
    "pickDomainFirst": "Choose a domain first.",
    "domains": {
      "commercial": "Commercial",
      "organization": "Organisation",
      "identity": "Users and access",
      "supplier": "Suppliers",
      "approval": "Approvals",
      "order": "Purchase orders",
      "request": "Requests",
      "platform": "Platform",
      "agreement": "Framework agreements",
      "budget": "Budgets",
      "catalogue": "Catalogue",
      "sourcing": "Sourcing",
      "security": "Security",
      "report": "Reports",
      "receiving": "Receiving",
      "onboarding": "Setup and imports",
      "invoice": "Invoices"
    }
  },
  "table": {
    "showing": "Showing {{from}}–{{to}} of {{total}}",
    "perPage": "Per page",
    "noResults": "No results",
    "loadError": "Could not load this data",
    "moreFields": "More fields ({{count}})",
    "pagination": "Pages",
    "page": "Page {{page}}",
    "name": "Name",
    "noMatch": "Nothing matches “{{search}}”",
    "noMatchHint": "Check the spelling, or clear the search to see everything.",
    "clearSearch": "Clear search"
  },
  "filters": {
    "anyStatus": "Any status",
    "anyone": "Anyone",
    "purchasingNode": "Purchasing unit",
    "from": "From",
    "to": "To",
    "dateRangeHelp": "You can set just one of the two dates if you prefer.",
    "resetSelections": "Reset selections",
    "clearAll": "Clear all",
    "clearFilters": "Clear filters",
    "updating": "Updating results…",
    "remove": "Remove {{name}}"
  },
  "errors": {
    "IDEMPOTENCY_KEY_CONFLICT": "This was already sent once with different details, and that first request went through. Refresh the page to see what was recorded before trying again.",
    "IDEMPOTENCY_REQUEST_IN_FLIGHT": "This is still being processed. Wait a moment, then try again.",
    "VALIDATION_FAILED": "Some of the submitted information is not valid.",
    "UNAUTHENTICATED": "Your session has ended. Please sign in again.",
    "FORBIDDEN": "You do not have permission to perform this action.",
    "NOT_FOUND": "The requested record could not be found.",
    "pageNotFound": "This page doesn't exist",
    "pageNotFoundBody": "Check the address, or go back to the home page.",
    "CONFLICT": "This action conflicts with the current state of the record.",
    "RATE_LIMITED": "Too many requests. Please wait a moment.",
    "SERVER_ERROR": "Something went wrong. The issue has been logged.",
    "INVALID_CREDENTIALS": "Invalid email address or password.",
    "ACCOUNT_LOCKED": "This account is temporarily locked after too many failed attempts.",
    "ACCOUNT_INACTIVE": "This account is not active. Contact your administrator.",
    "TENANT_INACTIVE": "This organisation is not currently active.",
    "DUPLICATE_CODE": "This code is already in use.",
    "DUPLICATE_RECORD": "A record with the same details already exists in your organisation. Open the existing one instead.",
    "ENTITY_IN_USE": "This record is still in use.",
    "CATEGORY_CYCLE_DETECTED": "A category cannot be placed beneath itself.",
    "CATEGORY_DEPTH_EXCEEDED": "The category tree cannot nest that deep.",
    "PERMISSION_MISSING": "You do not hold the permission required for this action.",
    "DELEGATION_OVERLAPS": "An overlapping delegation already exists.",
    "DELEGATION_SELF_TARGET": "A user cannot delegate authority to themselves.",
    "DELEGATION_INVALID_PERIOD": "The delegation period is not valid.",
    "CAPACITY_EXCEEDED": "Your organisation has no room left for this. Deactivate one, or talk to us about more capacity.",
    "RECORD_GOVERNED_BY_PURCHASING_UNIT": "This record belongs to a Purchasing Unit. Archive, deactivate or activate the Purchasing Unit on the Purchasing units page instead.",
    "PURCHASING_UNIT_ARCHIVED": "This Purchasing Unit is archived. Its history stays available, but it takes no new carts or requests.",
    "PURCHASING_UNIT_DETAILS_ARCHIVED": "These details are archived. A Purchasing Unit is archived only through its own Archive action on the Purchasing units page, so it cannot be linked to archived details.",
    "PURCHASING_UNIT_DETAILS_SHARED": "Another Purchasing Unit is linked to these details too. Link that unit to other details first, then archive this one.",
    "ENTITLEMENT_REQUIRED": "This capability is not part of your current agreement with Fidelen.",
    "SUBSCRIPTION_READ_ONLY": "Your account is read-only at the moment. Existing work can be completed; nothing new can be started.",
    "BUDGET_CLOSED_TO_NEW_SPEND": "This budget is closed to new spending. Choose another budget or ask your finance team.",
    "BUDGET_INSUFFICIENT": "The budget does not cover this request at its priced amount. Ask your finance team, then price it again.",
    "INVITATION_INVALID": "This link cannot be used. Ask the person who invited you to send a new invitation.",
    "METHOD_NOT_ALLOWED": "That action is not available here.",
    "PAYLOAD_TOO_LARGE": "What you sent is too large. Try a smaller file.",
    "SERVICE_UNAVAILABLE": "The service is briefly unavailable. Try again in a few minutes.",
    "TENANT_CONTEXT_MISSING": "Your organisation could not be identified. Sign in again.",
    "TENANT_MISMATCH": "This record belongs to another organisation.",
    "BRANCH_SCOPE_DENIED": "This is outside the purchasing units you work with.",
    "REGION_SCOPE_DENIED": "This is outside the regions you work with.",
    "IDEMPOTENCY_KEY_REQUIRED": "This request could not be sent safely. Refresh the page and try again.",
    "TENANT_SELECTION_REQUIRED": "Choose which organisation to sign in to.",
    "LOGIN_SELECTION_INVALID": "This sign-in can no longer continue. Sign in again with your email address and password.",
    "DELEGATION_EXCEEDS_AUTHORITY": "You cannot delegate more authority than you hold.",
    "PURCHASE_ORDER_NOT_DRAFT": "This purchase order is no longer a draft.",
    "PURCHASE_ORDER_ISSUED": "This purchase order has already been issued.",
    "PURCHASE_ORDER_NOT_ISSUED": "This purchase order has not been issued, or it was cancelled. Refresh to see where it stands.",
    "PURCHASE_ORDER_TERMINAL": "This purchase order is closed. Nothing more can be done with it.",
    "SUPPLIER_NOT_PROCURABLE": "This supplier cannot be bought from right now. Choose another supplier or ask procurement.",
    "ORDERED_QUANTITY_EXCEEDS_APPROVED": "The quantity is more than was approved.",
    "SUPPLIER_CHANGE_NOT_PERMITTED": "The supplier cannot be changed on this order. Cancel it and raise a new one.",
    "STALE_VERSION": "Someone changed this while you were working on it. Refresh to see the latest version, then try again.",
    "COMMITMENT_LEDGER_INCONSISTENT": "The budget ledger for this order does not match its lines. It needs reviewing before the order can be cancelled.",
    "QUALIFICATION_REVIEW_REASON_REQUIRED": "This qualification decision needs its review reason or evidence. Say what was checked, for example the documents reviewed.",
    "ACTION_LINK_INVALID": "This link cannot be used. Ask the buyer to send you a new one.",
    "ACTION_LINK_EXPIRED": "This link cannot be used. Ask the buyer to send you a new one.",
    "ACTION_LINK_USED": "This link cannot be used. Ask the buyer to send you a new one.",
    "ACTION_LINK_REVOKED": "This link cannot be used. Ask the buyer to send you a new one.",
    "PLAN_VERSION_IMMUTABLE": "This plan version is in use and cannot be changed. Create a new version.",
    "INVALID_SUBSCRIPTION_TRANSITION": "The subscription cannot move to that state from where it is now.",
    "SELF_APPROVAL_BLOCKED": "You cannot approve your own request. Someone else must decide it.",
    "SELF_RECEIPT_BLOCKED": "Your organisation's controls do not let you record this delivery yourself. Someone else must record it.",
    "SEGREGATION_OF_DUTIES_VIOLATION": "Your organisation's separation-of-duties rules stop you from doing this. Someone else must.",
    "ENTITY_INACTIVE": "This is inactive and cannot be used.",
    "CURRENCY_NOT_ENABLED": "This currency is not enabled for your organisation.",
    "CURRENCY_MISMATCH": "The currencies do not match. Amounts in different currencies cannot be combined.",
    "TAX_CODE_INACTIVE": "This tax code is inactive.",
    "FILE_TYPE_NOT_ALLOWED": "This type of file is not accepted.",
    "FILE_TOO_LARGE": "This file is too large.",
    "FILE_SCAN_FAILED": "This file could not be checked, so it was not accepted.",
    "IMPORT_FILE_INVALID": "This file could not be read. Use the template and try again.",
    "IMPORT_ROW_INVALID": "Some rows have problems. Check the report for each row.",
    "MFA_CHALLENGE_REQUIRED": "Confirm it is you with the code from your authenticator app to continue.",
    "MFA_ENROLMENT_REQUIRED": "Your role needs two-step sign-in. Set it up to continue.",
    "MFA_REQUIRED_FOR_ROLE": "Your role requires two-step sign-in, so it cannot be turned off.",
    "MFA_CODE_INVALID": "That code did not work. Type the code your app shows now, or a recovery code you have not used before.",
    "MFA_ENROLMENT_EXPIRED": "This setup has expired. Start again to get a new QR code.",
    "MFA_THROTTLED": "Too many attempts. Wait a few minutes, then try again.",
    "MFA_REAUTH_FAILED": "Your password or code was not right. Try again.",
    "unknown": "Something unexpected happened.",
    "APPROVAL_ROUTE_UNRESOLVABLE": "This request cannot be routed for approval. Ask an administrator to assign an approver."
  },
  "a11y": {
    "mainNavigation": "Main navigation",
    "quickNavigation": "Quick navigation",
    "skipToContent": "Skip to content",
    "toggleLanguage": "Switch language",
    "openMenu": "Open menu",
    "closeMenu": "Close menu",
    "closeDialog": "Close this dialog",
    "closeNamed": "Close {{name}}",
    "dismiss": "Dismiss"
  },
  "supplier": {
    "title": "Suppliers",
    "subtitle": "Your organisation's private vendor master — managed by HQ",
    "code": "Supplier code",
    "crNumber": "Commercial registration",
    "vatNumber": "VAT number",
    "status": "Relationship status",
    "qualificationStatus": "Qualification",
    "procurable": "Can be bought from",
    "procurableOnly": "Buyable suppliers only",
    "create": "Add supplier",
    "empty": "No suppliers recorded yet",
    "activate": "Activate relationship",
    "suspend": "Suspend relationship",
    "archive": "End relationship",
    "leadTime": "Lead time (days)",
    "paymentTerms": "Payment terms",
    "website": "Website",
    "branchNotice": "Suppliers and negotiated prices are managed by HQ only.",
    "twoGates": "Both the relationship AND the qualification must be active.",
    "name": "Name",
    "contacts": "Contacts",
    "primaryContact": "Primary",
    "email": "Email",
    "phone": "Phone",
    "supplier": "Supplier",
    "contact": "Contact",
    "importList": "Import list",
    "searchPlaceholder": "Search by name, code or number",
    "filterTitle": "Filter suppliers",
    "showSuppliers": "Show suppliers",
    "showCount": "Show suppliers: {{count}}",
    "qualificationState": {
      "draft": "Draft",
      "under_review": "Under review",
      "qualified": "Qualified",
      "active": "Qualified · active",
      "rejected": "Rejected",
      "suspended": "Qualification suspended"
    },
    "qualifiedUntil": "Qualified until {{date}}",
    "defaultCurrency": "Default currency",
    "portalAccounts": "Portal accounts",
    "openRecord": "Open supplier record",
    "edit": "Edit supplier",
    "quickView": "Quick view",
    "procurableNow": "Yes",
    "procurableNowSentence": "This supplier can be bought from now.",
    "cannotBuyTitle": "Cannot be bought from yet",
    "cannotBuyNext": "The relationship and the qualification are decided on the supplier's record.",
    "suspensionReason": "Reason for suspension",
    "emptyFiltered": "No suppliers match these filters",
    "emptyFilteredHint": "Change or clear the filters to see more suppliers.",
    "emptyHint": "Add a supplier, or import your supplier list.",
    "crHint": "10 digits",
    "vatHint": "15 digits, starting and ending with 3",
    "crShort": "CR number",
    "identity": "Identity and terms"
  },
  "qualification": {
    "title": "Qualification",
    "start": "Start qualification",
    "submit": "Submit for review",
    "approve": "Approve",
    "activate": "Activate qualification",
    "reject": "Reject",
    "suspend": "Suspend",
    "validUntil": "Valid until",
    "decidedBy": "Decided by",
    "decisionReason": "Decision reason",
    "checks": "Checks",
    "none": "Qualification not started",
    "history": "Qualification history",
    "reasonRequired": "A reason is required for this decision.",
    "notDecided": "Not decided"
  },
  "agreement": {
    "title": "Framework agreements",
    "subtitle": "Negotiated commercial terms with your suppliers",
    "reference": "Reference",
    "validFrom": "Valid from",
    "validTo": "Valid to",
    "currency": "Currency",
    "usableNow": "Usable now",
    "dueForRenewal": "Due for renewal",
    "create": "Add agreement",
    "empty": "No agreements",
    "activate": "Activate",
    "suspend": "Suspend",
    "terminate": "Terminate",
    "items": "Priced lines",
    "addItem": "Add line",
    "reprice": "Change price",
    "unitPrice": "Unit price",
    "supplierSku": "Supplier SKU",
    "moq": "Minimum order",
    "revision": "Revision",
    "superseded": "Superseded",
    "version": "Version",
    "repriceNotice": "A price change creates a new revision and preserves the previous price for existing orders.",
    "expiring": "Expiring soon",
    "terminateNotice": "Terminating ends this agreement permanently. Anything it prices stops being orderable, and it cannot be reactivated.",
    "createNotice": "The agreement is created as a draft. Agreeing terms does not make them orderable — somebody with agreement authority still activates it.",
    "edit": "Edit terms",
    "editNotice": "The supplier and the currency are fixed at creation. Changing the vendor would rewrite who was contracted with, and changing the currency would reinterpret every price already agreed.",
    "currencyFixedNotice": "The currency cannot be changed after the agreement is created.",
    "currentPrice": "Current price",
    "newPrice": "New price",
    "effectiveFrom": "Effective from",
    "paymentTerms": "Payment terms",
    "noneConsequence": "Without an active agreement, nothing from this supplier can be ordered.",
    "single": "Agreement",
    "validity": "Valid",
    "coverage": "Applies to",
    "coverageAll": "All purchasing units",
    "coverageSelected": "Selected purchasing units",
    "itemCount": "Lines",
    "usableOnly": "Usable today only",
    "dueOnly": "Due for renewal only",
    "emptyHint": "Agreements are created on the supplier they are with.",
    "notUsableTitle": "Nothing can be ordered under this agreement today",
    "terms": "Terms",
    "renewalNotice": "Renewal notice",
    "renewalNoticeDays_zero": "On the day it lapses",
    "renewalNoticeDays_one": "{{count}} day before it lapses",
    "renewalNoticeDays_two": "{{count}} days before it lapses",
    "renewalNoticeDays_few": "{{count}} days before it lapses",
    "renewalNoticeDays_many": "{{count}} days before it lapses",
    "renewalNoticeDays_other": "{{count}} days before it lapses",
    "lineCount": "Lines: {{count}}",
    "showEarlier": "Show earlier prices",
    "noItems": "No priced lines yet",
    "item": "Item",
    "lineTerms": "Terms",
    "effective": "Effective",
    "asAgreement": "As the agreement",
    "fromDate": "From {{date}}",
    "untilDate": "Until {{date}}",
    "validityNotSet": "Not set — needed before activation",
    "validToNotSet": "End date not set",
    "coverageNone": "No purchasing unit yet — needed before activation",
    "origin": "Created by",
    "originAward": "Award of",
    "activateTitle": "Activate this agreement?",
    "activateConfirm": "Activate agreement",
    "activateNotice": "Once active, its priced lines can be ordered at the purchasing units it applies to, until its end date.",
    "activateAwardNotice": "It came from an award: activating it also makes the catalogue items the award prepared orderable.",
    "blocker": {
      "validity_missing": "Set the end date in Edit terms before activating.",
      "validity_ended": "The end date has passed. Set a future end date in Edit terms before activating.",
      "coverage_missing": "Choose the purchasing units in Edit terms before activating."
    },
    "coverageSection": "Where it applies",
    "coverageSectionHint": "The purchasing units whose requests can be priced by this agreement.",
    "coverageRestrict": "Only the purchasing units chosen below",
    "coverageUnits": "Purchasing units",
    "coverageRestrictedToNone": "Restricted to no purchasing unit, the agreement cannot be activated.",
    "new": "New agreement",
    "chooseSupplier": "Which supplier is this agreement with?",
    "chooseSupplierHint": "An agreement is made with one supplier. Archived suppliers are not offered."
  },
  "catalogue": {
    "title": "Catalogue",
    "subtitle": "Approved items available to your purchasing unit",
    "search": "Search in Arabic or English",
    "price": "Agreed price",
    "taxRate": "Tax rate",
    "source": "Source",
    "supplierSource": "External supplier",
    "warehouseSource": "Internal warehouse",
    "orderable": "Available",
    "notOrderable": "Not available",
    "whyNot": "Why not available",
    "empty": "No matching items",
    "allCategories": "All categories",
    "allSuppliers": "All suppliers",
    "priceControlled": "This price comes from an approved agreement and cannot be edited.",
    "leadTime": "Lead time",
    "moq": "Minimum order",
    "admin": "Catalogue administration",
    "createItem": "Add item",
    "addSource": "Add source",
    "branchAccess": "Purchasing unit access",
    "item": "Item",
    "code": "Code",
    "unitOfMeasure": "Unit of measure",
    "packSize": "Pack size",
    "perUnit": "per {{unit}}",
    "warehouseNoPrice": "Supplied from the company warehouse — no supplier price applies.",
    "leadTimeDays": "Lead time (days)",
    "offCatalogueTitle": "Can't find what you need?",
    "offCatalogueHint": "Describe it and procurement will source it for you — you don't choose the supplier or the price.",
    "offCatalogueAction": "Request an off-catalogue item",
    "description": "Description",
    "sources": "Where it comes from",
    "sourcesHint": "Every source this item has, and whether it can be used now.",
    "agreedPriceForNode": "Agreed price for your purchasing unit, per unit",
    "orderingUnit": "Ordering unit",
    "suppliedBy": "Supplied by",
    "currentRequest": "Your cart",
    "linesInRequest": "Lines in it: {{count}}"
  },
  "unusable": {
    "item_inactive": "Item is not active",
    "source_inactive": "Source is not active",
    "supplier_not_active": "Supplier is not active",
    "supplier_not_qualified": "Supplier is not qualified",
    "agreement_missing": "No framework agreement",
    "agreement_not_active": "Agreement is not active",
    "agreement_not_started": "Agreement has not started",
    "agreement_expired": "Agreement has expired",
    "price_missing": "No agreed price",
    "price_not_yet_effective": "Price is not yet effective",
    "price_expired": "Price has expired",
    "agreement_item_inactive": "Agreement line is not active",
    "currency_not_enabled": "Currency is not enabled",
    "tax_code_unusable": "Tax code is not usable",
    "branch_not_permitted": "Not available to this purchasing unit",
    "warehouse_not_active": "Warehouse is not active",
    "warehouse_does_not_serve_branch": "Warehouse does not serve this purchasing unit",
    "currency_mismatch": "Priced in another currency"
  },
  "budget": {
    "title": "Budgets",
    "subtitle": "Operational spend control by purchasing unit, category and period",
    "period": "Period",
    "branchAll": "All purchasing units",
    "categoryAll": "All categories",
    "allocated": "Allocated",
    "requested": "Requested",
    "reserved": "Reserved",
    "committed": "Committed",
    "received": "Received",
    "invoiced": "Invoiced",
    "available": "Available",
    "utilisation": "Utilisation",
    "create": "Add budget",
    "empty": "No budgets",
    "allocate": "Allocate amount",
    "allocateHint": "Use a negative amount to reduce; a reason is then required.",
    "ledger": "Ledger",
    "ledgerSubtitle": "Every movement that touched this budget — the ledger is the authority",
    "movementType": "Movement",
    "bucket": "Bucket",
    "amount": "Amount",
    "balanceAfter": "Balance after",
    "noMovements": "No movements yet",
    "reconcile": "Reconcile with ledger",
    "consistent": "Figures match the ledger",
    "softControl": "Budget control is soft: going over does not block a request, it changes how it is approved.",
    "createPeriod": "Add period",
    "startsOn": "Starts on",
    "endsOn": "Ends on",
    "periodOrder": "The end date cannot be before the start date.",
    "changeStatus": "Change status",
    "activeNotice": "The budget takes new spend and can be allocated to.",
    "frozenNotice": "The allocation is fixed. Nothing new can be charged to it, and what is already committed still settles.",
    "closedNotice": "The budget refuses everything: no new spend, no reservation and no further allocation.",
    "reduce": "Reduce allocation",
    "budgetColumn": "Budget",
    "emptyHint": "Budgets are optional. Without one, a request carries the “no budget” condition, which approval rules can route on.",
    "informational": "Requested, received and invoiced are shown for information and are not part of the equation: available = allocated − reserved − committed.",
    "adjustAllocation": "Adjust allocation",
    "openLedger": "Open ledger",
    "reductionReason": "Reducing an allocation requires a reason.",
    "movementSequence": "Movements: {{count}}",
    "movements": "Movements",
    "reasonLine": "Reason: {{reason}}",
    "group": "Group",
    "source": "Source",
    "sourceRequest": "Request",
    "sourceOrder": "Purchase order",
    "by": "By",
    "appendOnly": "The ledger is append-only. A mistake is corrected by a further movement, never by editing.",
    "driftFound": "The figures did not match the ledger",
    "driftExplained": "They have been rebuilt from the ledger and the correction recorded. What changed:",
    "allocatedAfter": "Allocated after this movement",
    "afterIsPreview": "A preview until the ledger records it."
  },
  "approvalRule": {
    "title": "Approval rules",
    "subtitle": "Listed in the order the engine checks them. At most two human approval levels.",
    "create": "Add rule",
    "empty": "No rules",
    "priority": "Priority",
    "approvalType": "Approval type",
    "when": "WHEN",
    "then": "THEN",
    "next": "NEXT",
    "level": "Level",
    "addCondition": "Add condition",
    "addStep": "Add level",
    "stopsProcessing": "Stop evaluating later rules",
    "active": "Active",
    "effectiveFrom": "Effective from",
    "effectiveTo": "Effective to",
    "version": "Version",
    "precedence": "When several rules match: the lower priority number wins, then the more specific rule.",
    "noConditions": "Applies to every request",
    "field": "Field",
    "operator": "Comparison",
    "value": "Value",
    "approver": "Approver",
    "role": "Role",
    "slaHours": "Response time (hours)",
    "coverageComplete_zero": "Every purchasing unit has an eligible approver for each level of this rule ({{count}} units).",
    "coverageComplete_one": "Every purchasing unit has an eligible approver for each level of this rule ({{count}} unit).",
    "coverageComplete_two": "Every purchasing unit has an eligible approver for each level of this rule ({{count}} units).",
    "coverageComplete_few": "Every purchasing unit has an eligible approver for each level of this rule ({{count}} units).",
    "coverageComplete_many": "Every purchasing unit has an eligible approver for each level of this rule ({{count}} units).",
    "coverageComplete_other": "Every purchasing unit has an eligible approver for each level of this rule ({{count}} units).",
    "coverageGap_zero": "No purchasing unit is without an eligible approver for this rule.",
    "coverageGap_one": "{{count}} purchasing unit has no eligible approver for this rule.",
    "coverageGap_two": "{{count}} purchasing units have no eligible approver for this rule.",
    "coverageGap_few": "{{count}} purchasing units have no eligible approver for this rule.",
    "coverageGap_many": "{{count}} purchasing units have no eligible approver for this rule.",
    "coverageGap_other": "{{count}} purchasing units have no eligible approver for this rule.",
    "coverageConsequence": "Requests from these purchasing units will be refused at submission until an approver is assigned — the route is never run at fewer levels than configured.",
    "coverageGapNotDistinct_zero": "No purchasing unit has only one eligible person for several levels of this rule.",
    "coverageGapNotDistinct_one": "{{count}} purchasing unit has only one eligible person for several levels of this rule.",
    "coverageGapNotDistinct_two": "{{count}} purchasing units have only one eligible person for several levels of this rule.",
    "coverageGapNotDistinct_few": "{{count}} purchasing units have only one eligible person for several levels of this rule.",
    "coverageGapNotDistinct_many": "{{count}} purchasing units have only one eligible person for several levels of this rule.",
    "coverageGapNotDistinct_other": "{{count}} purchasing units have only one eligible person for several levels of this rule.",
    "coverageConsequenceNotDistinct": "Two levels need two people. The same person cannot sign twice, so these requests will be refused at the second level until another approver is assigned.",
    "coverageLevel": "level {{level}} ({{approver}})",
    "coverage": "Approver coverage",
    "deleteNotice": "The rule is removed from the policy. Requests will be routed by the next rule that matches, which may be a different route.",
    "deleteKeepsHistory": "Approvals already decided are unaffected — each workflow keeps its own snapshot of the rule that routed it.",
    "testRequest": "Test a request",
    "listTitle": "Rules in evaluation order",
    "listSubtitle": "The lower priority number is checked first",
    "emptyHint": "Until a rule is added, every request takes the fallback route set in Settings.",
    "stops": "Stops here",
    "continues": "Continues",
    "rule": "Rule",
    "route": "Route",
    "versionShort": "v{{version}}",
    "inForce": "In force",
    "notInForce": "Not in force",
    "deactivated": "Deactivated",
    "fromDate": "From {{date}}",
    "untilDate": "Until {{date}}",
    "edit": "Edit rule",
    "appliesTitle": "Changes apply to the next submission",
    "appliesBody": "A request already in approval keeps the route it was submitted with.",
    "howTitle": "How the rules are applied",
    "maxLevels": "A route has at most two sequential human levels, and never runs with fewer than it is configured with.",
    "noMatch": "When no rule matches, the fallback route set in Settings applies.",
    "summaryTitle": "Policy at a glance",
    "lastChanged": "Last changed",
    "deleteRule": "Delete rule",
    "and": "and ",
    "valueMissing": "a record that no longer exists",
    "noHuman": "No human approval needed",
    "levelShort": "Level {{level}}",
    "approverMissing": "No approver set",
    "slaShort": "{{hours}} h",
    "behaviourTitle": "How approval behaves",
    "behaviourSubtitle": "Your organisation's settings — they apply alongside the rules",
    "changeInSettings": "Change in Settings",
    "settingOn": "On",
    "settingOff": "Off",
    "newTitle": "New approval rule",
    "newSubtitle": "A rule decides the approval route for the requests it matches.",
    "backToRules": "Approval rules",
    "effectiveHint": "Leave empty to apply from now, with no end date.",
    "whenTitle": "When a request matches",
    "whenHint": "Every condition must hold. A rule with no conditions applies to every request.",
    "thenTitle": "Then route it to",
    "removeCondition": "Remove condition",
    "values": "Values",
    "chooseOne": "Choose…",
    "valueMissingFix": "This value refers to a record that no longer exists. Choose another value or remove the condition.",
    "valueFrom": "From",
    "valueTo": "To",
    "humanLevels": "Human levels: {{count}}",
    "approverType": "Approver type",
    "person": "Person",
    "personKept": "You cannot list people here; the person saved on this level is kept unless you change the approver type.",
    "previewTitle": "Route preview",
    "previewHint": "What this rule will do once saved. Test a request to see which rule wins.",
    "saveRule": "Save rule",
    "savingCreatesVersion": "Saving creates version {{version}}. Requests already in approval keep the route they were submitted with.",
    "savingCreatesRule": "Saving adds the rule at its priority. Requests already in approval keep the route they were submitted with.",
    "notSaved": "The rule was not saved",
    "fixFields": "Each problem below takes you to its field:",
    "codeHint": "Letters, numbers, - and _ only",
    "priorityHint": "A whole number from 1 to 9999. The lower number is checked first.",
    "slaHint": "Optional. A decision later than this is flagged as late.",
    "conditionN": "Condition {{n}}",
    "inCurrency": "In {{currency}}",
    "appliesWhen": "Applies when"
  },
  "simulator": {
    "title": "Approval rule simulator",
    "subtitle": "Try a hypothetical context before saving changes",
    "run": "Run simulation",
    "amount": "Amount",
    "branch": "Purchasing unit",
    "category": "Category",
    "budgetStatus": "Budget status",
    "result": "Result",
    "matchedRule": "Matched rule",
    "levels": "Approval levels",
    "reasons": "Reasons",
    "allMatches": "All matching rules",
    "noHumanApproval": "No human approval required",
    "sameEngine": "The simulator uses the same approval engine as production."
  },
  "request": {
    "title": "Purchase requests",
    "subtitle": "Your requests and where they are",
    "cart": "Cart",
    "cartSubtitle": "One cart may span several suppliers",
    "number": "Request number",
    "requester": "Requested by",
    "requiredBy": "Required date",
    "businessReason": "Business reason",
    "notes": "Notes",
    "submit": "Submit request",
    "cancel": "Cancel request",
    "empty": "No requests yet.",
    "emptyDescription": "Requests you create, or that you are allowed to see, will appear here.",
    "emptyFiltered": "No requests match your selections.",
    "emptyFilteredDescription": "Try changing the filters, or clear them.",
    "filterTitle": "Filter requests",
    "showRequests": "Show requests",
    "purchasingNodeHelp": "The site, department or work location the request came from.",
    "collection": {
      "all": "All requests",
      "mine": "My Requests"
    },
    "emptyCart": "Your cart is empty",
    "addFromCatalogue": "Add from catalogue",
    "remove": "Remove",
    "quantity": "Quantity",
    "unitPrice": "Unit price",
    "lineTotal": "Line total incl. tax",
    "total": "Total",
    "subtotal": "Subtotal",
    "tax": "Tax",
    "budgetImpact": "Budget impact",
    "expectedApproval": "Expected approval route",
    "noApprovalNeeded": "No human approval required",
    "timeline": "Request history",
    "nextStep": "Next step",
    "items": "Items",
    "approvedQuantity": "Approved quantity",
    "priceControlled": "The price and source are set by HQ and cannot be changed here.",
    "submitBlocked": "This request cannot be submitted as it stands.",
    "resubmit": "Resubmit",
    "offCatalogue": "Off-catalogue request",
    "offCatalogueSubtitle": "Describe what you need; procurement will source it",
    "itemName": "What do you need?",
    "specification": "Specification",
    "category": "Category",
    "unit": "Unit",
    "offCatalogueNotice": "You cannot name a supplier or a price — procurement decides those through controlled sourcing.",
    "submissionCount": "Submissions",
    "created": "Created",
    "amendSubtitle": "Amend the returned request and send it back for approval",
    "amend": "Amend",
    "reorder": "Reorder",
    "reorderPartial": "Some lines could not be added to your cart:",
    "reorderReason": {
      "no_usable_source": "no longer available at an approved price",
      "catalogue_item_removed": "no longer in the catalogue",
      "NOT_FOUND": "no longer available to your purchasing unit",
      "VALIDATION_FAILED": "cannot be ordered in this request’s currency",
      "ENTITY_INACTIVE": "no longer active"
    },
    "addToRequest": "Add to cart",
    "addedToCart": "Added to your cart",
    "openCart": "Open cart",
    "itemUnnamed": "Item",
    "priceNotResolved": "Price is confirmed when the cart is checked.",
    "purchaseRequest": "Purchase request",
    "noReason": "No reason given",
    "lineCount": "Lines: {{count}}",
    "showCount": "Show requests ({{count}})",
    "noLines": "This request has no lines.",
    "itemsSubtitle": "Lines: {{count}} · {{total}}",
    "details": "Details",
    "detailsRail": "Request details and history",
    "submittedBy": "Submitted {{date}} by {{name}}",
    "notSubmitted": "Not submitted yet",
    "recordViews": "Request record",
    "approvalTab": "Approval workflow",
    "whyThisRoute": "Why this route",
    "noApprovalYet": "The approval route is set when the request is submitted.",
    "noBudgetImpact": "No budget impact is recorded for this request.",
    "sourcingOutcome": {
      "title": "Sourcing completed",
      "subtitle": "The enquiry for this need was awarded. Procurement now holds it.",
      "enquiry": "Enquiry",
      "agreement": "Framework agreement",
      "agreementStatus": "Agreement state",
      "validTo": "Valid to",
      "coverage": "Applies to",
      "coverageAll": "All purchasing units",
      "items": "Catalogue items",
      "notBuyable": "Not buyable until procurement activates the agreement.",
      "noReservation": "No final budget reservation exists yet: the need has no agreed price. Budget and policy are checked again before anything is committed.",
      "reservationHeld": "The budget reserved for this request stays reserved until an order commits it or it is released."
    },
    "approvers": "Approvers",
    "levelN": "Level {{level}}",
    "withApprover": "With this approver",
    "nextLevel": "Next",
    "availableBefore": "Available before this request",
    "thisRequest": "This request",
    "availableAfter": "Available after this request",
    "openRecord": "Open request",
    "budgetAfter": "Available after this request: {{amount}}",
    "viewBudget": "View budget impact",
    "notSent": "The request was not sent",
    "itemNameHint": "Describe the item or service in plain words — procurement will find the right source.",
    "businessReasonHint": "Why it is needed — procurement reads this before deciding how to source it.",
    "specificationHint": "Size, material, colour, performance or installation details that help procurement source the right thing.",
    "noSupplierOrPrice": "No supplier or price needed",
    "whatHappensNext": "What happens next",
    "offCatalogueNext1": "Procurement reviews your need.",
    "offCatalogueNext2": "If it has to be sourced, procurement asks qualified suppliers to quote.",
    "offCatalogueNext3": "You follow each step on the request's own page.",
    "offCatalogueSendNote": "Procurement will review this need and decide the next controlled step.",
    "sendToProcurement": "Send to procurement",
    "offCatalogueNotAllowed": "Your role cannot ask for something outside the catalogue. If you need it, ask procurement.",
    "reviewAction": "Review & submit",
    "review": "Review & submit",
    "reviewSubtitle": "Check the details and buying controls before you submit.",
    "summary": "Summary",
    "budgetNotReservedYet": "Nothing is reserved yet — the budget is held only when you submit.",
    "buyingControls": "Buying controls",
    "checkedAgain": "Checked again when you submit.",
    "approvalLevel": "Level {{number}} approval",
    "submitExplains": "Submitting checks these controls again and reserves the budget."
  },
  "approvals": {
    "title": "Approvals",
    "subtitle": "Requests waiting on your decision",
    "empty": "Nothing is waiting for you",
    "amount": "Amount",
    "budgetStatus": "Budget",
    "exceptions": "Exceptions",
    "whyRouted": "Why this needs approval",
    "dueAt": "Due",
    "overdue": "Overdue",
    "level": "Level",
    "approve": "Approve",
    "reject": "Reject",
    "return": "Return for amendment",
    "partialApprove": "Partially approve",
    "decisionReason": "Reason",
    "reasonRequired": "A reason is required for this decision.",
    "approvedQuantity": "Approved quantity",
    "requestedQuantity": "Requested",
    "decide": "Decide",
    "escalatedTo": "Escalated to {{name}}",
    "history": "Approval history",
    "decidedBy": "by {{name}}",
    "onBehalfOf": "on behalf of {{name}}",
    "waitingForLevel": "Waiting for level {{level}}",
    "laterLevel": "Level {{level}}, after that",
    "approvedAmount": "Approved amount"
  },
  "order": {
    "title": "Purchase orders",
    "subtitle": "Every order and where each one has got to",
    "empty": "No purchase orders",
    "number": "Order number",
    "draftOrder": "Draft order",
    "draftOrderFor": "Draft order · {{supplier}}",
    "draftReference": "Reference",
    "draftNumberNote": "It gets an order number when it is issued.",
    "copyReference": "Copy reference",
    "referenceCopied": "Reference copied",
    "lifecycle": "Order",
    "vendorResponse": "Supplier",
    "fulfilment": "Delivery",
    "invoicing": "Invoicing",
    "issue": "Issue order",
    "send": "Send to supplier",
    "resend": "Resend",
    "amend": "Amend order",
    "cancel": "Cancel order",
    "document": "Document",
    "versions": "Versions",
    "version": "Version",
    "material": "Material change",
    "activity": "Sent and answered",
    "committed": "Committed",
    "fromRequest": "From request",
    "acknowledgementStale": "The supplier confirmed version {{acknowledged}}. This order is now at version {{current}} and needs confirming again.",
    "expectedDelivery": "Supplier's delivery date",
    "expectedDeliveryNone": "Not yet given",
    "expectedDeliveryLate": "After the date requested",
    "requestedBy": "Delivery requested by",
    "dispatches": "Dispatched consignments",
    "noDispatches": "Nothing dispatched yet",
    "deliveryNote": "Delivery note",
    "dispatchedAt": "Dispatched",
    "availability": "What the supplier can supply",
    "ordered": "Ordered",
    "available": "Available",
    "unavailable": "Short",
    "procurementRecord": "Procurement record",
    "recordComplete": "Complete",
    "recordActive": "Active",
    "generate": "Generate purchase orders",
    "generateHint": "One purchase order is created for each external supplier on this request. Lines sourced from a company warehouse are fulfilled internally and are never ordered from a supplier.",
    "generateDone": "Purchase orders are ready.",
    "generateReplay": "These orders already existed. Nothing was created a second time.",
    "generatedOrders": "Orders created",
    "internalTransferLines": "Fulfilled internally",
    "internalTransferHint": "Sourced from a company warehouse, so no supplier order was created.",
    "blockedSuppliers": "Suppliers that could not be ordered from",
    "unsourcedLines": "Lines with no usable source",
    "tracking": "Tracking",
    "issuedOn": "Issued {{date}}",
    "field": {
      "heading": "Field",
      "required_by": "Required by",
      "notes": "Notes",
      "lifecycle_status": "Order status",
      "quantity": "Quantity",
      "unit_of_measure": "Unit",
      "specification": "Specification",
      "unit_price": "Unit price",
      "tax_rate": "Tax rate",
      "line_subtotal": "Line subtotal",
      "line_tax": "Line tax",
      "line_total": "Line total",
      "order_subtotal": "Order subtotal",
      "order_tax": "Order tax",
      "order_total": "Order value"
    },
    "lineChange": {
      "added": "Line added in this version",
      "removed": "Line removed in this version"
    },
    "noFieldChanged": "No field the order carries changed in this version.",
    "differenceCaption": "What changed from version {{from}} to version {{to}}",
    "versionShort": "v{{version}}",
    "versionLabel": "Version {{version}}",
    "receiptRef": "Receipt {{reference}}",
    "receiptOn": "Receipt of {{date}}",
    "linesReceived": "{{received}} of {{lines}} lines received",
    "unitsReceived": "{{received}} of {{ordered}} {{unit}}",
    "noInvoices": "No invoice recorded",
    "cancelledOn": "Cancelled {{date}} · version {{version}} is final",
    "versionIssued": "Version {{version}} issued {{date}}",
    "versionIssuedSuperseded": "Version {{version}} issued {{date}} · version {{previous}} superseded",
    "ackCurrent": "Confirmed on version {{version}}",
    "ackOlderOnly": "Confirmed version {{version}} only",
    "ackAwaited": "Awaiting the supplier's response to version {{version}}",
    "lastReceipt": "last receipt {{date}}",
    "attention": {
      "title": "Needs attention",
      "query": "The supplier raised a query on version {{version}}",
      "declined": "The supplier declined version {{version}}",
      "partial": "The supplier can supply only part of version {{version}}",
      "lateDetail": "Supplier's date {{promised}}; required by {{required}}."
    },
    "amendConsequence": "Creates version {{next}}. Version {{current}} is kept.",
    "cancelConsequence": "Releases the outstanding commitment only.",
    "cancelConsequenceReceived": "Goods were received: what arrived stays committed, and only the rest goes back to its budget.",
    "cancelConsequenceDraft": "Never issued: no money moves.",
    "sendConsequence": "Sends version {{version}} to the supplier's contact.",
    "recordReceipt": "Record receipt",
    "versionCurrent": "Version {{version}} · current",
    "versionFinal": "Final",
    "versionIsCurrent": "Current",
    "versionSuperseded": "Superseded",
    "linesTitle": "Lines",
    "item": "Item",
    "received": "Received",
    "remaining": "Still expected",
    "messagesTitle": "Messages to the supplier",
    "messagesSubtitle": "What was sent about this order, and whether it arrived.",
    "recordRail": "Order actions and history",
    "actions": "Actions",
    "moreActions": "More actions",
    "actionsFor": "Actions for {{number}}",
    "actionsForDraft": "Actions for this draft order",
    "versionHistory": "Version history",
    "versionHistorySubtitle": "Each issued version is an immutable document. A new version never rewrites an old one.",
    "noVersions": "Not issued yet.",
    "changeType": {
      "issue": "Issued",
      "amendment": "Amendment",
      "cancellation": "Cancellation"
    },
    "whatChanged": "What changed",
    "viewDocument": "Document — version {{version}}",
    "orderCard": "Order",
    "supplier": "Supplier",
    "crNumber": "CR",
    "purchasingNode": "Purchasing Unit",
    "deliverTo": "Deliver to",
    "orderDate": "Order date",
    "notIssuedYet": "Not issued yet",
    "orderValue": "Order value",
    "notes": "Notes",
    "closureReason": "Reason it was closed",
    "supplierResponses": "Supplier responses",
    "supplierResponsesSubtitle": "What the supplier told us, and when.",
    "noSupplierResponse": "No response from the supplier yet.",
    "dispatchRecorded": "Dispatch recorded",
    "receiptsTitle": "Receipts",
    "receiptsSubtitle": "Recorded by the buyer. Evidence, not a status — each against the version it was received on.",
    "receipt": "Receipt",
    "receivedOn": "Date",
    "receivedBy": "Received by",
    "receiptLines": "Lines accepted",
    "nothingAccepted": "Nothing accepted",
    "againstVersion": "Against version",
    "noReceipts": "Nothing received yet",
    "invoicesRecorded": "Invoices recorded: {{count}} · {{amount}}",
    "linesSubtitle": "Lines: {{count}} · ordered and received per line. Invoices are recorded against the whole order.",
    "versionCount": "Versions: {{count}}",
    "filterTitle": "Filter purchase orders",
    "filterResponse": "Supplier response",
    "supplierFilterHint": "Suppliers on orders you can open.",
    "showOrders": "Show purchase orders",
    "showCount": "Show purchase orders: {{count}}",
    "emptyFiltered": "No purchase order matches these filters"
  },
  "vendor": {
    "home": {
      "nav": "Home",
      "title": "What needs you",
      "subtitle": "Your orders and enquiries with this buyer, by what each needs next.",
      "toAcknowledge": "Orders to confirm",
      "toAcknowledgeHint": "The buyer is waiting for you to confirm the current version.",
      "toDispatch": "Orders to dispatch",
      "toDispatchHint": "Confirmed, and nothing sent yet.",
      "toInvoice": "Orders to invoice",
      "toInvoiceHint": "Goods sent, and no invoice on the order yet.",
      "enquiries": "Enquiries awaiting your quote",
      "enquiriesHint": "Open for your prices until the deadline.",
      "withBuyer": "Waiting on the buyer",
      "withBuyerHint": "You asked a question or declined. The buyer answers or amends the order.",
      "empty": "Nothing here now.",
      "more_zero": "See all",
      "more_one": "{{count}} more — see all",
      "more_two": "{{count}} more — see all",
      "more_few": "{{count}} more — see all",
      "more_many": "{{count}} more — see all",
      "more_other": "{{count}} more — see all",
      "requiredBy": "Required by {{date}}",
      "dispatchedOn": "Sent {{date}}",
      "issuedOn": "Issued {{date}}",
      "deadline": "Deadline {{date}}",
      "quoteAction": "Send your quote",
      "allClear": "Nothing needs you right now. New orders and enquiries appear here as the buyer sends them."
    },
    "orders": "Orders",
    "ordersSubtitle": "Purchase orders sent to you",
    "noOrders": "No orders yet",
    "awaitingCount_zero": "No orders waiting for your confirmation",
    "awaitingCount_one": "{{count}} order waiting for your confirmation",
    "awaitingCount_two": "{{count}} orders waiting for your confirmation",
    "awaitingCount_few": "{{count}} orders waiting for your confirmation",
    "awaitingCount_many": "{{count}} orders waiting for your confirmation",
    "awaitingCount_other": "{{count}} orders waiting for your confirmation",
    "acknowledge": "Confirm receipt",
    "acknowledgeVersion": "Confirm version {{version}}",
    "acknowledgedOn": "Confirmed {{date}} (version {{version}})",
    "reacknowledge": "This order has changed since you confirmed it. Please review version {{version}} and confirm again.",
    "deliverTo": "Deliver to",
    "notes": "Notes for the buyer",
    "signInTitle": "Supplier sign-in",
    "signInSubtitle": "Sign in to see the orders sent to you.",
    "buyer": "Buyer",
    "buyerHint": "The organisation code the buyer gave you.",
    "respond": "Reply to this order",
    "respondHint": "Confirm it, give a delivery date, report a shortfall, ask a question or decline.",
    "answerType": "Your answer",
    "typeAcknowledged": "Confirm the order",
    "typeQuery": "Ask a question",
    "typePartial": "Report a shortfall",
    "typeDeclined": "Decline the order",
    "deliveryDate": "Expected delivery date",
    "deliveryDateHint": "The date you expect to deliver. The buyer keeps the date they asked for.",
    "reason": "Reason",
    "reasonRequired": "Please say why — the buyer needs a reason to act on this.",
    "send": "Send answer",
    "sent": "Your answer has been sent to the buyer.",
    "availabilityHint": "Say how much of each line you can supply. You can report less than was ordered, never more.",
    "availableQuantity": "You can supply",
    "lineNote": "Note for this line",
    "dispatch": "Record a dispatch",
    "dispatchHint": "Tell the buyer a consignment has left, and the delivery note that goes with it.",
    "deliveryNoteRef": "Delivery note reference",
    "deliveryNoteHint": "Your own reference for this consignment. Sending it twice records one dispatch, not two.",
    "dispatchedAt": "Dispatched at",
    "recordDispatch": "Record dispatch",
    "dispatchRecorded": "Dispatch recorded.",
    "document": "View the order document",
    "answerNotes": "Message with your answer",
    "dispatchNotes": "Notes about this consignment",
    "portalNavigation": "Supplier portal",
    "enquiries": "Enquiries",
    "answerEffect": {
      "acknowledged": "You accept this version of the order. Add the date you expect to deliver, if it differs.",
      "partially_available": "State, line by line, how much you can supply. The buyer decides what happens next.",
      "query": "Sends your question to the buyer. Your answer to the order stays outstanding.",
      "declined": "A reason is required. The buyer is notified."
    },
    "dispatchSeparately": "To report a shipment, use “Record a dispatch” below — it is a report, not an answer.",
    "invoiceNotShown": "Not shown here",
    "noOrdersHint": "Purchase orders appear here when the buyer sends them.",
    "orderColumn": "Order",
    "datesColumn": "Dates",
    "nextColumn": "Next action",
    "versionShort": "v{{version}}",
    "requestedBy": "Requested by",
    "yourDate": "Your date",
    "notGivenYet": "Not given yet",
    "afterRequested": "After the date requested",
    "nothingNeeded": "Nothing needed",
    "acknowledgeOrder": "Confirm the order",
    "acknowledgeNewVersion": "Confirm the new version",
    "respondToOrder": "Respond"
  },
  "secureAction": {
    "viewDocument": "View the order document",
    "rfqTitle": "Request for a quote",
    "rfqIntro": "You have been invited to quote. Sign in to the supplier portal to send your prices.",
    "linkVersionNote": "This link was sent with version {{link}}; your answer is recorded against it. The order has since been updated to version {{current}}.",
    "shellLabel": "Secure supplier link",
    "scopeGeneric": "This link covers one order for one supplier and gives no access to anything else.",
    "scopeOrder": "This link is specific to {{number}} and to {{supplier}}. It gives no access to other orders, other suppliers or the buyer's system.",
    "noPayment": "Fidelen does not process payment between buyer and supplier.",
    "unavailableTitle": "This link is no longer available",
    "unavailableBody": "Ask the buyer who sent it to issue a new link.",
    "reference": "Reference",
    "poTitle": "Purchase order",
    "versionOf": "version {{version}}",
    "issuedBy": "Issued by",
    "to": "To",
    "issued": "Issued",
    "requiredBy": "Delivery requested by",
    "validUntil": "This link works until",
    "amendedTitle": "This order was amended — version {{version}}",
    "amendedBody": "Version {{version}} replaces version {{previous}}. Your acknowledgement of version {{previous}} no longer applies — please respond to this version.",
    "statusTitle": "Where this order stands",
    "yourResponse": "Your response",
    "invoiceNotShown": "Not shown on this link",
    "linesTitle": "Lines — version {{version}}",
    "linesSubtitle": "Lines: {{count}} · {{total}}",
    "respond": "Respond",
    "respondTitle": "Your response",
    "respondHint": "Choose one. A question does not commit you to the order.",
    "answers": {
      "confirm": "Acknowledge and confirm the requested date",
      "confirmEffect": "You accept every line of the order for delivery by {{date}}.",
      "confirmEffectNoDate": "You accept every line of the order as sent.",
      "propose": "Acknowledge and propose a delivery date",
      "proposeEffect": "You accept the order and give the date you can deliver by. The buyer sees it beside the date they asked for.",
      "query": "Ask a question",
      "queryEffect": "Sends your question to the buyer. Your response to the order stays outstanding.",
      "decline": "Decline this order",
      "declineEffect": "A reason is required. The buyer is notified."
    },
    "portalOnly": "Partial availability and dispatches are reported in the supplier portal.",
    "chooseFirst": "Choose a response first.",
    "proposedDate": "The date you can deliver by",
    "proposedDateHint": "Requested: {{date}}.",
    "dateRequired": "Enter the date you can deliver by.",
    "question": "Your question",
    "declineReasonLabel": "Reason for declining",
    "noteToBuyer": "Note to the buyer",
    "noteOptional": "Optional.",
    "questionRequired": "Write your question for the buyer.",
    "reasonRequired": "A reason is required to decline.",
    "send": "Send response",
    "sentTitle": "Response sent",
    "sentBody": "{{answer}} — {{when}}. The buyer has been notified.",
    "sentDate": "Delivery date you gave: {{date}}",
    "sentUsed": "This link has now been used. For anything more on this order, contact the buyer.",
    "failedTitle": "Your response was not sent",
    "failedBody": "The connection failed before the buyer received it. Your entries are still on this page. Send again — and if it fails a second time, contact the buyer directly.",
    "buyerContact": "Buyer contact:",
    "copy": "Copy my response",
    "copied": "Copied",
    "sendAgain": "Send again",
    "alreadyAcknowledged": "Version {{version}} was acknowledged on {{date}}. No further response is needed on this link.",
    "completedReadOnly": "This order is complete. It is kept here for your records."
  },
  "purchasingUnit": {
    "title": "Purchasing units",
    "subtitle": "Where your organisation buys and receives goods — each unit's region, cost centre and receiving location are set here",
    "empty": "No purchasing units defined",
    "create": "Add purchasing unit",
    "kind": "Represents",
    "kindHint": "What this purchasing unit stands for. Only the Branch and Warehouse kinds link to operational details in Fidelen.",
    "kindLocked": "What a unit represents cannot be changed. Create a new one instead.",
    "noLink": "Not linked",
    "unlinkedKindNotice": "This kind has no operational details in Fidelen to link to, which is expected.",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "deactivateNotice": "This releases the slot and keeps every record. Say why, so the change can be explained later.",
    "resolveLink": "Resolve link",
    "resolveLinkNotice": "This records that the mismatch is known and accepted. It changes no status and releases no capacity.",
    "staleLink": "Its operational details (“{{name}}”) are no longer active",
    "capacityUsed": "{{used}} of {{limit}} active",
    "capacityUnlimited": "{{used}} active — no limit",
    "capacityFull": "No room left. Deactivate a unit, or talk to us about more capacity.",
    "archive": "Archive",
    "archiveNotice": "Archiving keeps this unit's history, references and permissions, and frees its slot. It cannot be undone: an archived unit is never activated again. Say why, so the change can be explained later.",
    "archived": "Archived",
    "operational": {
      "title": "Operational details",
      "hint": "Where this unit buys and receives: its region, its cost centre and whether it receives deliveries.",
      "record": "Linked details",
      "recordNew": "Set up new details with this unit",
      "code": "Operational code",
      "codeHint": "The code imports and reports know these details by. Leave it empty to use the unit's own code.",
      "nameSync": "Renaming the unit renames its details too, so requests, budgets and reports show the same name.",
      "readOnly": "You can read these details here but not change them.",
      "archived": "This purchasing unit is archived, so its details are kept as they are and can no longer be changed.",
      "relinkHint": "Save to link these details to the unit."
    }
  },
  "receiving": {
    "title": "Receiving",
    "subtitle": "Deliveries waiting to be recorded",
    "empty": "Nothing waiting to be received",
    "alreadyAccepted": "Already accepted",
    "remaining": "Still outstanding",
    "deliveredQuantity": "Quantity that arrived",
    "acceptedQuantity": "Quantity accepted",
    "acceptedHint": "You can accept up to what is still outstanding. Anything more is recorded as an over-delivery.",
    "exceptionType": "If something was wrong",
    "exceptionReason": "What was wrong",
    "deliveryNoteRef": "Supplier delivery note",
    "receiptNotes": "Notes on this delivery",
    "receiveEverything": "Everything arrived correctly",
    "receiveEntered": "Record what I entered",
    "recorded": "Receipt recorded.",
    "history": "Receiving history",
    "noReceipts": "Nothing received yet",
    "closeShortHint": "Use this when the outstanding quantity will never arrive under this order. It releases the budget still held for it and cannot be undone.",
    "closeShortReason": "Why is the remainder being closed?",
    "closeShortAction": "Close short",
    "exceptionQuantity": "Quantity affected",
    "exceptionQuantityRequired": "Enter how many units this applies to.",
    "orderColumn": "Order",
    "datesColumn": "Dates",
    "supplierAnswer": "Supplier answer",
    "receive": "Receive",
    "emptyHint": "Orders appear here once they are issued and expected at your purchasing units.",
    "receiveOrder": "Receive order",
    "acceptAllRemaining": "Accept all remaining",
    "lineMeta": "Line {{number}} · {{unit}}",
    "lineReceived": "Fully received",
    "lineClosedShort": "Closed short",
    "addException": "Report a problem",
    "deliveryDetails": "Delivery details",
    "wholeDelivery": "The delivery as a whole",
    "overdueExplain": "Use this when a delivery that was expected has not arrived.",
    "reportOverdue": "Report that it is late",
    "overdueEntered": "Late delivery reported",
    "closeOrderShort": "Close order short",
    "closeShortTitle": "Close this order short?",
    "notRecorded": "Receipt not recorded",
    "onLine": "Line {{number}}: {{name}}.",
    "commitHint": "Only what arrived today is recorded. A receipt cannot be edited afterwards — a correction is a further receipt.",
    "enteredLines": "Lines entered: {{count}}",
    "acceptedNow": "Accepted now: {{quantity}} {{unit}}",
    "receiptSummary": "Lines: {{lines}} · against version {{version}}",
    "receiptLine": "{{name}} — arrived {{delivered}}, accepted {{accepted}}",
    "unknownLine": "A line no longer on the order",
    "problem": {
      "notANumber": "Enter a number, for example 12 or 2.5.",
      "acceptedOverDelivered": "Accepted cannot be more than what arrived.",
      "acceptedOverRemaining": "You can accept up to {{remaining}}. Report the rest as an over-delivery.",
      "unexplainedShortfall": "Some of what arrived was not accepted. Report the problem so the reason is recorded.",
      "reasonMissing": "Say what was wrong."
    }
  },
  "invoice": {
    "title": "Supplier invoices",
    "captureHint": "Record the invoice the supplier sent you. Fidelen stores it as evidence — it does not issue, approve or pay it.",
    "record": "Record an invoice",
    "missing": "No supplier invoice recorded yet",
    "number": "Supplier's invoice number",
    "date": "Invoice date",
    "subtotal": "Subtotal",
    "tax": "Tax",
    "total": "Total",
    "file": "Supplier's invoice PDF",
    "fileHint": "PDF only, up to 10 MB. Stored privately and only visible to authorised people.",
    "save": "Record invoice",
    "download": "Download the invoice PDF",
    "exceedsOrder": "This invoice is for more than the order value. Recorded as sent; nothing is approved automatically."
  },
  "sourcing": {
    "title": "Sourcing",
    "subtitle": "Controlled enquiries to your qualified suppliers",
    "deadline": "Responses due",
    "closed": "Closed",
    "responses": "Responses",
    "responseCount": "{{answered}} of {{invited}} answered",
    "requirement": "What is being asked for",
    "invited": "Invited suppliers",
    "comparison": "Compare the responses",
    "comparisonHint": "The same facts for each supplier. Fidelen does not score or rank them — the choice is yours.",
    "noQuotes": "No supplier has responded yet",
    "supplier": "Supplier",
    "total": "Total",
    "validUntil": "Price held until",
    "moq": "Minimum order",
    "leadTime": "Lead time",
    "availability": "Availability",
    "expired": "Expired",
    "days_zero": "{{count}} days",
    "days_one": "{{count}} day",
    "days_two": "{{count}} days",
    "days_few": "{{count}} days",
    "days_many": "{{count}} days",
    "days_other": "{{count}} days",
    "choose": "Choose",
    "chooseSupplier": "Choose {{supplier}}",
    "decision": "Record your decision",
    "awardHint": "Awarding turns the winning offer into a draft framework agreement for the purchasing unit the need came from. It does not place an order or commit any budget, and nothing is bought from it until somebody with agreement authority activates it.",
    "awardReason": "Why this supplier?",
    "award": "Award to the chosen supplier",
    "noAwardReason": "Why is nobody being awarded?",
    "noAward": "Close with no award",
    "awarded": "Awarded",
    "agreementCreated": "Framework agreement {{reference}} was created. Buying now follows your normal request and approval rules.",
    "awardCatalogueItems": "Buy it from the catalogue as:",
    "awardNotInCatalogue": "Nothing in the catalogue is priced by this award yet, so it cannot be ordered until catalogue administration adds an item for it.",
    "awardDraftAgreement": "Framework agreement (draft):",
    "awardAgreement": "Framework agreement:",
    "awardDraftCoverage": "Applies to: {{units}}",
    "awardDraftCoverageAll": "Applies to: all purchasing units",
    "awardDraftCoverageNone": "Applies to: no purchasing unit yet — needed before activation",
    "awardDraftValidTo": "Valid to {{date}}",
    "awardDraftValidityNeeded": "Valid to: needed before activation",
    "awardDraftNotBuyable": "Nothing can be bought from it until the agreement is activated.",
    "awardWithdrawn": "Award withdrawn on {{date}}: the need went back to sourcing.",
    "awardDraftCatalogueItems": "Once the agreement is activated, it is bought from the catalogue as:",
    "agreementActive": "Framework agreement {{reference}} is active. Buying now follows your normal request and approval rules.",
    "documents": "Documents",
    "fromRevision": "revision {{revision}}",
    "sendToSourcing": "Send to sourcing",
    "sendToSourcingHint": "Procurement will raise an enquiry to approved suppliers. The supplier and the price are decided here, never by whoever raised the need.",
    "startRfq": "Start enquiry",
    "rfqTitle": "What is being sourced",
    "currencyHint": "Suppliers quote in this currency. One currency per enquiry.",
    "terms": "Terms",
    "linesHeading": "What suppliers will quote",
    "linesHint": "Carried from the need. Suppliers name their own prices — no price is set here.",
    "linesEmpty": "No lines carried from the need.",
    "createRfq": "Create enquiry",
    "cancelRfq": "Cancel enquiry",
    "closeOutcomeHint": "No award closes an enquiry that ran but produced nothing worth awarding. Cancel closes one that should not have run. Both are recorded with your reason.",
    "inviteHeading": "Invite qualified suppliers",
    "inviteHint": "Only suppliers you have qualified and may buy from are listed. Choosing several is normal — this is an enquiry, not a preference.",
    "openRfq": "Open to suppliers",
    "noEligibleSuppliers": "No approved suppliers are available to invite.",
    "workColumn": "Work item",
    "originColumn": "From",
    "keyDateColumn": "Key date",
    "notYetOpen": "Not yet open to suppliers",
    "itemCount": "Items: {{count}}",
    "needsFailed": "The needs waiting for an enquiry could not be loaded",
    "queueEmpty": "Nothing waiting in sourcing",
    "queueEmptyHint": "Needs handed to sourcing, and the enquiries raised for them, appear here.",
    "queueFootnote": "Needs appear here before an enquiry is raised. “Start enquiry” opens the enquiry form — nothing is created until you confirm there.",
    "kindNeed": "Need",
    "kindRfq": "Enquiry",
    "noNumberYet": "No number until opened",
    "startSubtitle": "Create a draft enquiry from this need. Nothing is sent to suppliers until you open it.",
    "startNotAllowed": "Your role cannot raise enquiries. Procurement raises them from the needs in the sourcing queue.",
    "notCreated": "The enquiry was not created",
    "detailsHeading": "Enquiry details",
    "rfqTitleHint": "What suppliers will see as the enquiry’s name.",
    "deadlineHint": "Applies once the enquiry is opened to suppliers. Your local time.",
    "currencyFromRequest": "From the request. One currency per enquiry.",
    "addLine": "Add line",
    "lineNumber": "Line {{number}}",
    "lineItem": "Item",
    "termsHeading": "Terms and notes",
    "termsHint": "Shown to suppliers when the enquiry is opened. Keep to response conditions — not award or purchase commitments.",
    "internalNotes": "Internal notes",
    "internalNotesHint": "Not visible to suppliers.",
    "draftSummary": "Draft summary",
    "fromRequest": "From request",
    "linesCount": "Lines",
    "noneYet": "None yet",
    "enquiryNumber": "Enquiry number",
    "numberWhenOpened": "Assigned when opened",
    "notContactedTitle": "Suppliers are not contacted yet",
    "notContactedBody": "Creating the draft only records the enquiry. You invite qualified suppliers and open it in the next step.",
    "next1": "The draft enquiry is created.",
    "next2": "You review the draft.",
    "next3": "You invite qualified suppliers.",
    "next4": "You open it for responses.",
    "createNote": "Creates a draft linked to {{request}}. Nothing is sent to suppliers.",
    "createNoteNoRequest": "Creates a draft enquiry. Nothing is sent to suppliers.",
    "sourceRequest": "Source request",
    "request": "Request",
    "needNotInSourcing": "This need is not waiting for sourcing (it is: {{status}}). Check it before raising an enquiry.",
    "eyebrowDraft": "Enquiry draft",
    "numberAssignedWhenOpened": "Number assigned when opened",
    "draftDescription": "Review the enquiry, choose the qualified suppliers, then open it for responses.",
    "stepsLabel": "Where this enquiry stands",
    "stepSuppliers": "Suppliers",
    "stepOpen": "Open",
    "definitionHeading": "Enquiry definition",
    "definitionSubtitle": "Set when the draft was created.",
    "currencyLabel": "Currency",
    "plannedDeadline": "Planned response deadline",
    "category": "Category",
    "created": "Created",
    "termsShown": "Terms · shown to suppliers when opened",
    "notesInternal": "Internal notes · procurement only",
    "none": "None",
    "searchSuppliers": "Search suppliers",
    "inviteColumn": "Invite",
    "inviteSupplier": "Invite {{supplier}}",
    "eligibility": "Eligibility",
    "qualification": "Qualification",
    "qualifiedBadge": "Qualified",
    "qualifiedUntil": "Qualified until {{date}}",
    "noEndDate": "No end date",
    "readyToOpen": "Ready to open?",
    "selectedSuppliers": "Selected suppliers",
    "invitedSoFar": "Invited so far",
    "nothingSentYet": "None — nothing sent yet",
    "willBeInvited": "Will be invited",
    "noneSelected": "None selected yet",
    "whatOpeningDoes": "What opening does",
    "opening1": "Invites the selected suppliers.",
    "opening2": "Asks them to respond by {{deadline}}.",
    "opening3": "Each supplier sees only its own invitation.",
    "opening4": "Nothing is awarded, agreed or ordered.",
    "openNote": "Opening invites the selected suppliers and lets them respond until the deadline. At least one supplier is needed.",
    "deadlinePassed": "Response deadline passed",
    "invitedNote": "Every invited supplier is listed, including any that did not reply.",
    "invitedNoteClosed": "The response window is closed; no reply is not a quote.",
    "revisionSent": "Revision {{revision}} · sent {{date}}",
    "inclTax": "incl. tax {{amount}}",
    "expiredNotChoosable": "Past its validity — cannot be awarded",
    "chosenOffer": "Chosen offer",
    "chooseFirst": "Choose an offer in the comparison first.",
    "awardReasonHint": "Required. Recorded with the award as sourcing evidence.",
    "awardConsequence": "The winning quote's price, tax, lead time and validity become a draft agreement. It is activated separately, before anything can be ordered through the normal request process.",
    "orCloseNoAward": "Or close with no award",
    "noAwardExplain": "No supplier is selected from this enquiry. The originating request stays as it is.",
    "closeReasonHint": "Required to close.",
    "usualLeadTime_zero": "usual lead time {{count}} days",
    "usualLeadTime_one": "usual lead time {{count}} day",
    "usualLeadTime_two": "usual lead time {{count}} days",
    "usualLeadTime_few": "usual lead time {{count}} days",
    "usualLeadTime_many": "usual lead time {{count}} days",
    "usualLeadTime_other": "usual lead time {{count}} days",
    "requestedBy": "Requested by",
    "purchasingNode": "Purchasing unit",
    "requiredBy": "Required by",
    "startedWithoutRequest": "None — started without a request",
    "notAvailableToYou": "Not available with your access",
    "notStatedOnRequest": "Not stated on the request"
  },
  "vendorRfq": {
    "listTitle": "Enquiries",
    "listSubtitle": "Requests for a quote sent to you",
    "none": "No enquiries yet",
    "title": "Enquiry",
    "deadline": "Reply by",
    "closed": "This enquiry is no longer accepting responses.",
    "requirement": "What is being asked for",
    "unitPrice": "Your price per {{unit}}",
    "yourOffer": "Your offer",
    "taxRate": "Tax rate (%)",
    "validUntil": "Price held until",
    "validUntilHint": "How long you will hold this price. Separate from the reply deadline above.",
    "moq": "Minimum order quantity",
    "leadTime": "Lead time (days)",
    "availability": "Availability",
    "notes": "Notes for the buyer",
    "submit": "Send my quote",
    "revise": "Send a revised quote",
    "reviseUnchanged": "Nothing has changed since the quote you just sent. Change a price or a term to send a revision.",
    "submitted": "Your quote has been sent.",
    "lastOffer": "Your current offer",
    "revision": "revision {{revision}}",
    "attachments": "Documents",
    "noAttachments": "No documents attached yet.",
    "attachFile": "Add a document",
    "attach": "Attach",
    "attachHint": "PDF only, up to 10 MB. Attached to the offer you have submitted.",
    "currency": "Currency",
    "fromBuyer": "From {{buyer}}",
    "unitPriceHint": "In {{currency}}, excluding tax. The tax rate is entered once below and applies to every line.",
    "buyerTerms": "Buyer terms",
    "taxRateHint": "Optional. Applied to every line.",
    "moqHint": "Optional. In the requested unit.",
    "leadTimeHint": "Optional. Days after the order to deliver.",
    "availabilityHint": "Optional. In your own words — for example, in stock, or part now and the rest in two weeks.",
    "notesHint": "Optional — a question, a condition, anything the buyer should know.",
    "documentsAfterSending": "You can attach PDF documents (up to 10 MB each) after you send your quote. They are attached to the offer you sent.",
    "readyTitle": "Ready to send?",
    "readyBody": "Sending shares this quote with {{buyer}} for their evaluation. It is an offer, not an order — you can send a revised quote until the reply deadline.",
    "readyBodyNoBuyer": "Sending shares this quote with the buyer for their evaluation. It is an offer, not an order — you can send a revised quote until the reply deadline.",
    "phaseOpen": "Open for response",
    "phaseClosed": "Closed for response"
  },
  "onboarding": {
    "title": "Setup and imports",
    "subtitle": "What is configured, what is outstanding, and how to load master data.",
    "readiness": "Go-live readiness",
    "ready": "Ready",
    "outstanding_zero": "Nothing outstanding",
    "outstanding_one": "{{count}} outstanding",
    "outstanding_two": "{{count}} outstanding",
    "outstanding_few": "{{count}} outstanding",
    "outstanding_many": "{{count}} outstanding",
    "outstanding_other": "{{count}} outstanding",
    "derivedHint": "Every step below is read from your live configuration. There is nothing to tick — a step completes when the records it needs exist and are in use, such as active or in force. Inactive and archived records are counted, but they do not complete a step.",
    "optional": "optional",
    "configured": "{{count}} configured",
    "notConfigured": "Not configured yet",
    "owner": "Owner",
    "ownerYou": "you",
    "ownerNoRole": "No role yet",
    "ownerNobody": "Nobody holds it yet",
    "ownerDetails": "Owner details",
    "ownerRolesTitle": "Roles that can complete this step",
    "ownerPeopleCount": "Active people: {{count}}",
    "ownerPeopleHidden": "Names are shown to those who manage users.",
    "ownerNoRoleHint": "No role holds the right to do this step, so nobody can complete it. Add the right to a role under Roles.",
    "ownerNobodyHint": "The role exists, but no active person holds it. Give it to a user under Users.",
    "ownerHint": "The owner is whoever holds the right to do the step. It follows your roles, so it is never out of date.",
    "steps": {
      "regions": "Regions",
      "branches": "Purchasing units",
      "categories": "Category hierarchy",
      "users": "Users and roles",
      "defaults": "Language, timezone and currency defaults",
      "approval_rules": "Approval rules",
      "budgets": "Budgets",
      "suppliers": "Suppliers",
      "agreements": "Framework agreements",
      "catalogue": "Catalogue with usable prices",
      "purchasing_path": "Purchases can be completed at each purchasing unit"
    },
    "staffingTitle": "Can a purchase be completed at each purchasing unit?",
    "staffingHint": "Somebody must be able to raise it, every approval level must have somebody to decide it, and somebody must be able to receive it without receiving their own request or what they approved.",
    "staffingAllClear": "Every purchasing unit that can raise a purchase can also complete one.",
    "nodeBlocked": "Blocked",
    "nodeAtRisk": "At risk",
    "nodeIdle": "Nobody can raise a purchase here yet",
    "approvalUnstaffed": "An approval level has nobody who can decide it.",
    "approvalNotDistinct": "Two approval levels would need the same person.",
    "receivingUnstaffed": "Nobody may receive deliveries here.",
    "receivingAtRisk": "Everyone who may receive here also raises or approves purchases here, so their own purchases need somebody else to receive them.",
    "import": "Import master data",
    "importHint": "Upload a CSV or Excel file. It is checked first and nothing is created until you apply it.",
    "entity": "What to import",
    "branchesHint": "Each row sets up the operational details of a purchasing unit: its code, English and Arabic names, region, cost centre, phone, email and city. The import does not create purchasing units. Add a unit for those details, or link them to an existing unit, under Purchasing units.",
    "openPurchasingUnits": "Open Purchasing units",
    "file": "File",
    "columns": "Columns",
    "requiredColumns": "Required",
    "check": "Check the file",
    "history": "Recent imports",
    "noImports": "No imports yet.",
    "nothingWrittenYet": "Nothing has been created yet. Applying will create only the rows marked ready.",
    "apply_zero": "Apply {{count}} rows",
    "apply_one": "Apply {{count}} row",
    "apply_two": "Apply {{count}} rows",
    "apply_few": "Apply {{count}} rows",
    "apply_many": "Apply {{count}} rows",
    "apply_other": "Apply {{count}} rows",
    "applied_zero": "No rows were created.",
    "applied_one": "{{count}} row was created.",
    "applied_two": "{{count}} rows were created.",
    "applied_few": "{{count}} rows were created.",
    "applied_many": "{{count}} rows were created.",
    "applied_other": "{{count}} rows were created.",
    "problems": "Rows that need attention",
    "allRows": "All rows",
    "line": "Line",
    "field": "Field",
    "reason": "Reason",
    "outcome": "Outcome",
    "stepNeeded": "Needed to go live",
    "done": "Done",
    "open": "Open",
    "fileHint": "Accepted: {{formats}} · up to {{rows}} rows per file.",
    "cannotRun": "Your role can read imports but not run them.",
    "rows": "Rows",
    "rowsApplied": "{{applied}} of {{total}} created",
    "rowsValid": "{{valid}} of {{total}} ready",
    "rejectedTitle": "File rejected",
    "rejectedNoReason": "The file could not be read.",
    "applyFinal": "Applying cannot be undone.",
    "nothingToApply": "No row is ready to apply — fix the file and check it again.",
    "checksum": "File fingerprint",
    "noRows": "No rows were read.",
    "countTotal": "Rows",
    "countValid": "Ready",
    "countInvalid": "With problems",
    "countApplied": "Created",
    "countSkipped": "Already existed"
  },
  "supplierFacts": {
    "title": "Reliability facts",
    "hint": "Counted from your own transactions with this supplier over the last twelve months. These are facts, not a rating.",
    "ordersIssued": "Orders issued",
    "ordersAcknowledged": "Orders acknowledged",
    "responseTime": "Average response",
    "deliveriesReceived": "Deliveries received",
    "deliveriesOnTime": "Delivered on time",
    "shortDeliveries": "Short deliveries",
    "invoicesCaptured": "Invoices captured",
    "hours": "{{hours}}h",
    "noData": "No responses yet"
  },
  "reports": {
    "hubSubtitle": "Live operational reporting, drawn from the records themselves.",
    "dashboards": "Dashboards and reports",
    "records": "Records",
    "recordsHint": "The rows behind the figures — filtered and exported under the same scope.",
    "recordsSubtitle": "The same query the figures were counted from.",
    "noExportRight": "You can read these reports but not export them. Ask an administrator for the export permission.",
    "export": "Export",
    "from": "From",
    "to": "To",
    "groupBy": "Group by",
    "window": "Period",
    "scope": "Locations",
    "allLocations": "All locations",
    "locationCount_zero": "No locations",
    "locationCount_one": "{{count}} location",
    "locationCount_two": "{{count}} locations",
    "locationCount_few": "{{count}} locations",
    "locationCount_many": "{{count}} locations",
    "locationCount_other": "{{count}} locations",
    "generatedAt": "Produced",
    "howToRead": "How to read this",
    "viewRecords": "View the records",
    "noRows": "Nothing to show for this period and scope.",
    "empty": "No figures for this window.",
    "available": "Available reports",
    "report": "Report",
    "computing": "Computing this report from your records — nothing is cached.",
    "choose": "Choose a report or a record set from the list."
  },
  "dashboard": {
    "openReports": "Open reports",
    "yourWork": "Your work",
    "myRequests": "My Requests",
    "awaitingMyDecision": "Awaiting my decision",
    "noFigures": "There is nothing to show here for your access.",
    "newRequest": "New purchase request",
    "moreFigures": "More figures",
    "attention": "Needs attention",
    "review": "Review",
    "decisionsTitle": "Decisions waiting on you",
    "decisionsCount": "Waiting: {{count}}",
    "openQueue": "Open queue",
    "noDecisions": "Nothing is waiting on your decision.",
    "raisedBy": "Raised by",
    "due": "Due",
    "overdue": "Overdue",
    "budgetTitle": "Budget position",
    "noBudgets": "No budget is set up for the locations you can see.",
    "overAllocation": "Over its allocation",
    "availableOf": "{{available}} available of {{allocated}}",
    "noExceptions": "No receiving exceptions in this window.",
    "spendTitle": "Ordered, by category",
    "spendBasis": "orders issued in the window, not cancelled",
    "noSpend": "No orders were issued in this window.",
    "otherCategories": "Other categories",
    "latestRequests": "My latest requests",
    "viewAll": "View all"
  },
  "vendorInvoice": {
    "title": "Your invoices for this order",
    "hint": "Send the invoice you issued for this order. Fidelen records it against the order version and keeps it as evidence — it is not a payment request and does not decide when you are paid.",
    "send": "Send invoice",
    "none": "You have not sent an invoice for this order yet."
  },
  "vendorProfile": {
    "title": "Company details",
    "subtitle": "What this organisation has on record for your company. To change anything here, contact them.",
    "noContacts": "No contacts are recorded."
  },
  "vendorAgreements": {
    "title": "Agreements",
    "subtitle": "The framework agreements you are party to with this organisation.",
    "empty": "You have no framework agreements with this organisation."
  },
  "catalogueAdmin": {
    "title": "Catalogue administration",
    "subtitle": "What exists, where it comes from, and who may see it",
    "empty": "No catalogue items yet.",
    "create": "Add item",
    "orderable": "Orderable",
    "orderableYes": "Orderable",
    "orderableNo": "Not orderable",
    "access": "Purchasing Unit access",
    "restricted": "Restricted to selected purchasing units",
    "allNodes": "Available to every purchasing unit",
    "sources": "Sources",
    "manageSources": "Sources",
    "noSources": "This item has no source, so nobody can order it.",
    "addSource": "Add source",
    "removeSource": "Remove",
    "sourceType": "Source type",
    "agreementItem": "Agreement line",
    "agreementItemHint": "The price comes from the agreement line. It is never typed here.",
    "warehouseNotice": "A warehouse source is fulfilled internally. It creates no purchase order and never reaches a supplier.",
    "nameEn": "Name (English)",
    "nameAr": "Name (Arabic)",
    "descriptionEn": "Description (English)",
    "descriptionAr": "Description (Arabic)",
    "accessHint": "Choose which Purchasing Units may see this item. Leaving it unrestricted makes it available to every purchasing unit.",
    "restrictToggle": "Restrict to selected Purchasing Units",
    "saveAccess": "Save access",
    "restrictedToNone": "Restricted with no purchasing unit selected means nobody can see this item."
  },
  "portalUser": {
    "invite": "Invite portal account",
    "invited": "Portal account created",
    "invitedNotice": "An account was created for {{email}}.",
    "password": "Password",
    "passwordOnce": "This password is shown once and cannot be read again. Hand it over now; if it is lost, invite the account again.",
    "capabilities": "What this account may do",
    "acknowledgeOrders": "Acknowledge purchase orders",
    "submitQuotes": "Submit quotes",
    "uploadInvoices": "Submit invoices",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "deactivateNotice": "The supplier will no longer be able to sign in with this account, answer enquiries or acknowledge orders.",
    "noneConsequence": "Without a portal account this supplier cannot answer an enquiry, acknowledge an order or submit an invoice."
  },
  "tenant": {
    "profile": "Organisation profile",
    "profileSubtitle": "Who your organisation is, as your documents record it",
    "identity": "Name",
    "registration": "Registration and contact",
    "registrationHint": "These appear on the documents your organisation issues and receives.",
    "legalNameEn": "Legal name (English)",
    "legalNameAr": "Legal name (Arabic)",
    "timezone": "Time zone",
    "fixed": "Set when the organisation was created",
    "readOnly": "You can see this profile but not change it."
  },
  "exceptions": {
    "none": "Nothing departs from the purchasing rules.",
    "rule": "Rule: {{rule}}",
    "tone": {
      "exception": "Needs intervention",
      "warning": "Advisory",
      "neutral": "For information"
    }
  },
  "partial": {
    "includeLine": "Include {{name}}",
    "requested": "Requested {{quantity}}",
    "earlierLimit": "an earlier level allowed {{quantity}}",
    "unitPrice": "{{price}} each",
    "overCeiling": "At most {{quantity}}. An approver can reduce a quantity, never raise it.",
    "positive": "Enter a quantity above zero, or leave the line out.",
    "summaryLines": "Lines approved",
    "summaryUnits": "Units approved",
    "summaryApproved": "Approved value",
    "summaryNotApproved": "Not approved",
    "previewNote": "A preview: the figures are recalculated and checked when you confirm."
  },
  "decision": {
    "approveLast": "Approve the request as it stands. Completes the approval.",
    "approveNext": "Approve the request as it stands. Moves to level {{next}}.",
    "partialConsequence": "Approve some lines or reduced quantities. Reason required.",
    "returnTitle": "Return for amendment",
    "returnConsequence": "Send back for a change. The request stays open.",
    "rejectTitle": "Reject",
    "rejectConsequence": "End the request. Reason required.",
    "currentLevel": "Current level",
    "levelOf": "Level {{level}} of {{count}}",
    "dueOn": "Due {{date}}",
    "actingFor": "You hold this step by delegation from {{name}}, until {{until}}. Your decision is recorded as a delegated decision, with both names.",
    "confirmActingFor": "You are deciding for {{name}}. Both names are recorded.",
    "timelineActingFor": "You hold this step by delegation from {{name}}.",
    "approveDialogTitle": "Approve this request?",
    "approveCommit": "Confirm approval",
    "approveOutcomeLast": "Your approval is recorded at level {{level}}, the last level. The request becomes approved.",
    "approveOutcomeNext": "Your approval is recorded at level {{level}}. The request moves to level {{next}} — {{name}}.",
    "stillTrue": "Still true on this request",
    "noteOptional": "Note (optional)",
    "noteHint": "Visible to the requester and to later approvers.",
    "partialDialogTitle": "Approve part of this request",
    "partialCommit": "Approve lines: {{count}} · {{amount}}",
    "partialOutcomeLast": "This is the last level: the request becomes approved for the quantities you keep.",
    "partialOutcomeNext": "The quantities you keep go to level {{next}}, which can reduce them further but never raise them.",
    "reason": "Reason",
    "reasonVisible": "Required. Visible to the requester and to later approvers.",
    "reasonRequired": "Give a reason.",
    "nothingReduced": "Nothing is reduced yet. Lower a quantity or leave a line out — to approve everything, use Approve.",
    "nothingApproved": "Every line is left out. To end the request, use Reject; to send it back, use Return for amendment.",
    "returnDialogTitle": "Return this request for amendment",
    "returnCommit": "Return to requester",
    "returnExplains": "The request goes back to the requester to change. It stays open and keeps its reference, its history and the approvals given so far — it is not rejected.",
    "whatShouldChange": "What should change",
    "whatShouldChangeHint": "Required. The requester sees this as the thing to act on.",
    "instructionRequired": "Say what should change.",
    "rejectDialogTitle": "Reject this request?",
    "rejectExplains": "Rejecting ends the request. It cannot be resubmitted under this reference.",
    "rejectAlternative": "If it could be fixed, return it for amendment instead: it stays open and keeps its history.",
    "returnInstead": "Return instead",
    "rejectCommit": "Reject request",
    "whyTitle": "Why this request needs a decision",
    "panelTitle": "Your decision",
    "workflowTitle": "Approval workflow",
    "budgetUnavailable": "Budget context is not available for this request.",
    "decide": "Decide",
    "selfTitle": "You raised this request",
    "selfBody": "The purchasing rules do not allow approving your own request. It is with {{holder}}. Nothing was recorded.",
    "sodTitle": "A different approver is needed",
    "sodBody": "You have already decided an earlier level of this request, and each level needs a different approver. Nothing was recorded.",
    "staleTitle": "This approval has moved on",
    "staleBy": "{{name}} decided it at {{at}}. Nothing was recorded for you.",
    "staleUnknown": "Someone else decided it while you were reviewing. Nothing was recorded for you.",
    "reload": "Reload",
    "notYoursTitle": "Not waiting on you",
    "notYoursBody": "Only the approver for this level may decide it. It is with {{holder}}.",
    "submitted": "submitted {{date}} by {{name}}",
    "requestTotal": "Request total",
    "sources": "Sources",
    "item": "Item",
    "quantity": "Quantity",
    "unitPrice": "Unit price",
    "lineTotal": "Line total incl. tax",
    "offCatalogue": "Off catalogue",
    "resultTitle": "Decision recorded",
    "result": {
      "approve": "Approved",
      "partial_approve": "Partly approved",
      "return": "Returned for amendment",
      "reject": "Rejected"
    },
    "resultBy": "By {{name}} at {{at}}.",
    "resultByFor": "By {{name}}, for {{for}}, at {{at}}.",
    "nowAt": "The request is now: {{status}}.",
    "backToQueue": "Back to approvals",
    "openRequest": "Open the request",
    "overdueTitle": "Waiting past its approval service level",
    "overdueSince": "Was due {{date}}.",
    "slaRule": "Approval service level",
    "validUntil": "valid until {{date}}"
  },
  "amend": {
    "title": "Amend {{number}} — version {{next}}",
    "stepOf": "Step {{step}} of {{count}} · {{name}}",
    "stepName": {
      "intro": "What amending means",
      "edit": "Draft the new version",
      "review": "Review changes",
      "confirm": "Confirm"
    },
    "creates": "Amending creates version {{next}} of {{number}}.",
    "keeps": "Version {{current}} stays in the record as an issued document and can always be read. Nothing already received or invoiced is changed.",
    "currentVersion": "Current version",
    "currentVersionValue": "Version {{version}} · issued {{date}}",
    "supplierAck": "Supplier acknowledgement",
    "ackConfirmed": "Confirmed on version {{version}}",
    "ackOlder": "Confirmed version {{version}} only",
    "ackOutstanding": "Outstanding on version {{version}}",
    "receivedSoFar": "Received so far",
    "invoicedSoFar": "Invoiced so far",
    "retained": "{{what}} · retained",
    "nothingReceived": "Nothing received yet",
    "nothingInvoiced": "No invoice recorded",
    "consequenceNew": "A new version will be created: version {{next}}.",
    "consequenceKept": "Version {{current}} remains historical and readable.",
    "consequenceAckMaybe": "If a quantity or the required date changes, the supplier's acknowledgement is reset and they are asked to respond again.",
    "consequenceAckReset": "The supplier's acknowledgement is reset: they are sent version {{next}} and asked to respond again, and their earlier link stops working.",
    "consequenceAckKept": "Only the notes change: the supplier's acknowledgement stands and no new message is sent.",
    "consequenceControls": "Every quantity stays within what was approved and not below what was received — checked again when you confirm. The budget commitment moves by the difference.",
    "start": "Start amendment",
    "draftTitle": "Drafting version {{next}}",
    "draftBody": "Version {{current}} remains the issued order until you confirm. The supplier sees no change yet.",
    "orderedReceived": "Ordered {{ordered}} · received {{received}}",
    "locked": "Nothing left to deliver — this line is locked.",
    "quantityFor": "Quantity in version {{next}}",
    "quantityForLine": "Quantity in version {{next}} — {{name}}",
    "boundsReceived": "From {{min}} (already received) up to {{max}} (approved).",
    "boundsNone": "More than 0, up to {{max}} (approved).",
    "problem": {
      "invalid": "Enter a number, such as 4 or 2.5.",
      "positive": "Enter a quantity above 0. To stop the order entirely, cancel it instead.",
      "below_received": "Not below {{min}}: that much has already been received.",
      "above_approved": "Not above {{max}}: that is what the request was approved for."
    },
    "requiredBy": "Required by",
    "notes": "Notes on the order",
    "notesHint": "Printed on the order document. A change to the notes alone does not reset the supplier's acknowledgement.",
    "nothingYet": "Change a quantity, the date or the notes to draft a new version.",
    "discard": "Discard draft",
    "review": "Review changes",
    "reviewTitle": "Review changes — version {{current}} to version {{next}}",
    "fieldQuantity": "{{name}} — quantity",
    "effectReducedReceived": "Reduced by {{by}}. Not below the {{received}} already received, so permitted.",
    "effectReduced": "Reduced by {{by}}.",
    "effectIncreased": "Increased by {{by}}, within the {{approved}} approved.",
    "effectEarlier": "Earlier date. Resets the supplier's acknowledgement.",
    "effectLater": "Later date. Resets the supplier's acknowledgement.",
    "effectNotes": "Wording only.",
    "orderValue": "Order value",
    "effectValueDown": "Reduced by {{amount}}. The commitment is released by the same amount.",
    "effectValueUp": "Increased by {{amount}}. The commitment grows by the same amount.",
    "recalculated": "Totals are recalculated exactly by the server when you confirm.",
    "backToEdit": "Back to edit",
    "continue": "Continue",
    "confirmBody": "Version {{next}} becomes the current order at {{total}}. Version {{current}} is superseded and kept as an issued document.",
    "unaffected": "Unaffected and still linked to the order: {{evidence}}.",
    "invoiceRef": "invoice {{number}}",
    "listSeparator": ", ",
    "noEvidenceYet": "Nothing has been received or invoiced against this order yet.",
    "reason": "Reason for the new version",
    "reasonHint": "Required. Recorded with the version and in the audit trail.",
    "staleTitle": "This order changed while you were working on it",
    "staleBody": "Someone changed it first, so version {{next}} was not issued. Start again from the latest version.",
    "startAgain": "Start again from the latest version",
    "back": "Back",
    "issue": "Issue version {{next}}",
    "doneTitle": "Version {{version}} issued",
    "doneBody": "{{when}} by {{name}}. Version {{previous}} is superseded and kept.",
    "doneSupplier": "The supplier is sent version {{version}} and asked to respond again.",
    "recordedChanges": "Recorded changes",
    "backToOrder": "Back to the order"
  },
  "cancel": {
    "title": "Cancel {{number}}?",
    "titleDraft": "Cancel this draft order?",
    "subtitle": "Version {{version}} · {{supplier}}",
    "draftNoMoney": "This order was never issued and holds no commitment. Cancelling it moves no money.",
    "lockedRule": "Cancelling releases the remaining outstanding commitment only",
    "lockedRuleBody": "Existing received, invoiced and history evidence is retained. Nothing is deleted or reversed.",
    "invoicesOutcome": "Retained: {{numbers}}. Recorded against the whole order.",
    "receivedTitle": "Goods have been received against this order",
    "linesAtCancellation": "Lines at cancellation",
    "item": "Item",
    "notDelivered": "Not delivered",
    "lineOutcome": {
      "fully_received": "Fully received",
      "closed_short": "Closed short earlier",
      "part_cancelled": "Part cancelled",
      "cancelled": "Cancelled"
    },
    "released": "Released",
    "retained": "Retained",
    "reason": "Reason for cancellation",
    "reasonHint": "Required. Shown on the order, in the audit trail and in the notice sent to the supplier.",
    "theSupplier": "The supplier",
    "staleTitle": "This order changed while you were reviewing it",
    "staleReceipts": "Goods were received against it in the meantime, so what cancelling does has changed. Nothing was cancelled — review it again.",
    "reviewAgain": "Review again",
    "keepOpen": "Keep order open",
    "commit": "Cancel order",
    "commitRelease": "Cancel order · release {{amount}}",
    "done": "{{number}} cancelled. {{released}} of commitment released.",
    "supplierTold": "{{supplier}} is notified, and their link to this order stops working. Every issued version stays readable.",
    "receivedKeeps": "What arrived stays committed, because it was spent. Only the part that will not arrive goes back to its budget. Received, invoiced and history evidence is kept. Nothing is deleted or reversed.",
    "byBudget": "By budget",
    "budget": "Budget",
    "notBudgeted": "Not in a budget",
    "unbudgeted": "{{amount}} of this order is outside every budget, so nothing moves for it.",
    "notCancellable": "This order is closed and can no longer be cancelled.",
    "refusedTitle": "This order cannot be cancelled until its budget ledger is reviewed",
    "ledgerDisagrees": "{{budget}}: the ledger holds {{held}}; the order's lines account for {{expected}}.",
    "staleConsequences": "What cancelling does to the money changed in the meantime: a receipt, a close-short or an amendment. Nothing was cancelled. Review it again."
  },
  "platform": {
    "shellBadge": "Platform operations",
    "reviewNotice": "Operator console for local owner review, composed from Fidelen's shared components. It is not an approved design and not a release.",
    "nav": {
      "label": "Platform operations",
      "overview": "Overview",
      "organisations": "Organisations",
      "security": "Sign-in security"
    },
    "login": {
      "title": "Fidelen operator sign-in",
      "subtitle": "For Fidelen staff who run the platform. Customers and suppliers sign in elsewhere.",
      "boundary": "This sign-in grants no access to a customer's purchasing or a supplier's portal."
    },
    "tenantStatus": {
      "provisioning": "Being set up",
      "active": "Active",
      "suspended": "Suspended",
      "closed": "Closed"
    },
    "overview": {
      "title": "Platform overview",
      "subtitle": "What the platform's own records say today.",
      "organisations": "Organisations",
      "activeNote": "{{count}} active",
      "pendingAdministrators": "Administrators not yet activated",
      "pendingNote": "Invited, and not signed in yet",
      "pilots": "Pilots",
      "pilotsNote": "Pilot records in any state",
      "subscriptions": "Subscriptions",
      "subscriptionsNote": "Subscription records in any state",
      "byStatus": "Organisations by status",
      "howToRead": "How to read these figures",
      "defOrganisations": "Organisations counts every provisioned organisation, by its lifecycle status.",
      "defPending": "Administrators not yet activated counts organisations whose first administrator has not set a password yet.",
      "defPilots": "Pilots and subscriptions count records, not revenue.",
      "defNoRevenue": "No revenue, spend or infrastructure figure is shown: the platform keeps no approved projection for them."
    },
    "orgs": {
      "title": "Organisations",
      "subtitle": "Every customer organisation on the platform. Their purchasing is theirs; this list shows who they are and where they stand.",
      "create": "Create organisation",
      "search": "Search by name or identifier",
      "status": "Status",
      "allStatuses": "All statuses",
      "empty": "No organisations yet.",
      "emptyFiltered": "No organisation matches this search.",
      "organisation": "Organisation",
      "administrator": "First administrator",
      "commercial": "Plan or pilot",
      "created": "Created"
    },
    "org": {
      "pilot": "Pilot",
      "noPlan": "No plan",
      "adminActivated": "Activated",
      "adminInvited": "Invitation pending",
      "tabs": {
        "label": "Organisation sections",
        "overview": "Overview",
        "commercial": "Subscription and capacity",
        "onboarding": "Setup",
        "history": "History"
      },
      "identity": "Organisation",
      "nameEn": "Name (English)",
      "nameAr": "Name (Arabic)",
      "legalName": "Legal name",
      "cr": "Commercial registration",
      "vat": "VAT number",
      "defaults": "Language · currency · time zone",
      "created": "Created",
      "onboarded": "Provisioning completed",
      "notYet": "Not yet",
      "administrator": "First administrator",
      "noAdministrator": "No administrator on record.",
      "adminName": "Name",
      "adminEmail": "Email",
      "adminState": "State",
      "invitationExpires": "Invitation expires",
      "resend": "Resend invitation",
      "resendTitle": "Resend the administrator's invitation?",
      "resendBody": "A new invitation link is sent and the previous one stops working at once. No second administrator is created.",
      "resendCommit": "Resend invitation",
      "resent": "A new invitation was issued. The previous link no longer works.",
      "subscription": "Subscription",
      "noSubscription": "No subscription on record.",
      "plan": "Plan",
      "subscriptionStatus": "Status",
      "starts": "Starts",
      "ends": "Ends",
      "noPilot": "No pilot on record.",
      "pilotStatus": "Pilot state",
      "pilotDays": "Pilot days",
      "liveAt": "Went live",
      "configurationDeadline": "Configuration deadline",
      "capacity": "Purchasing-unit capacity",
      "capacityHint": "Active purchasing units against the plan's limit.",
      "capacityUsed": "In use",
      "capacityLimit": "Limit",
      "capacityRemaining": "Remaining",
      "unlimited": "No limit",
      "atCapacity": "This organisation is at its purchasing-unit limit.",
      "notInScope": "Not in this console",
      "notInScopeBody": "Billing collection, discounts and plan changes are not operated from this review console. The release stage of the commercial features is an open owner decision.",
      "setup": "Setup progress",
      "setupProgress": "{{complete}} of {{required}} required steps done",
      "required": "Required",
      "historyTitle": "Commercial history",
      "historyHint": "Commercial events recorded for this organisation, newest first.",
      "noHistory": "No commercial events yet."
    },
    "create": {
      "title": "Create organisation",
      "subtitle": "Provision a customer organisation and invite its first administrator.",
      "organisation": "Organisation",
      "slug": "Identifier",
      "slugHint": "Lowercase letters, numbers and hyphens. Used to sign in; it cannot be reused.",
      "commercialContext": "Commercial context",
      "commercialContextHint": "A pilot starts on the pilot profile; Layer 1 starts on the full plan.",
      "contextPilot": "Pilot",
      "contextLayer1": "Layer 1 plan",
      "defaultLanguage": "Default language",
      "languageAr": "Arabic",
      "languageEn": "English",
      "administrator": "First administrator",
      "administratorHint": "They receive an invitation to set their own password.",
      "syntheticOnly": "In this review environment use synthetic names and addresses only. The invitation goes to the local mail capture, not to a real inbox.",
      "commit": "Create organisation and invite",
      "doneTitle": "Organisation created",
      "invitationHanded": "The invitation was handed to the mail transport. That is not proof it was delivered or read.",
      "invitationNotSent": "The organisation exists, but the invitation was not sent. Resend it from the organisation once mail is working.",
      "whatHappened": "What was created",
      "nextStep": "The administrator activates the account from the invitation, then sets up the organisation. It cannot place orders until setup is complete.",
      "open": "Open the organisation"
    }
  }
}
